import dayjs from "dayjs";
import autoTable from 'jspdf-autotable'
import ReportCoreMixin from '@shared_mixins/report/report.core.mixin.js';

export default {
    mixins: [
        ReportCoreMixin
    ],
    data () {
        return {
            category1AreaChartInstance: null,
            category1BarChartInstance: null,
            PAR_BarChartInstance: null,
            PAR_Category1AreAChartInstance: null,
            category1PieChartInstance: null,
            category1PieChartInstanceImg: null
        }
    },
    computed: {
        headerInfo () {
            const _user_input_company_name = this.reportData.info.users.find(({ criteria_name }) => criteria_name === "회사명")
            return {
                company_id: this.reportData?.info?.company.id,
                request_id: this.reportData?.info?.id,
                company_name: _user_input_company_name?.value || this.reportData?.info?.company?.company_name,
                vendor_code: this.reportData?.info?.vendor_code,
                published_date: this.reportData?.info?.completed_ts
            }
        },
        companyInfo () {
            if (!this.reportData?.parser.values.length) {
                return {
                    "근로자_계약직": ' - ', "근로자_정규직": ' - ', "매출액": ' - ', "매출액_구분": ' - ', "매출액_통화": ' - ', "소재국가": ' - ', "주요생산품목": ' - ', "회사명": ' - '
                }
            } else {
                const _company_info_field = ["근로자_계약직", "근로자_정규직", "매출액", "매출액_구분", "매출액_통화", "소재국가", "주요생산품목", "회사명"]
                const _company_info = [ ...this.reportData?.parser.values ].reduce((_info, _value) => {
                    if (_company_info_field.includes(_value.criteria_name)) {
                        _info[_value.criteria_name] = !_value.value.length
                            ? "(없음)"
                            : _value.value[0]
                    } else {
                        _info[_value.criteria_name] = ' - '
                    }

                    return _info
                }, {})

                const _company_info_exist_keys = Object.keys(_company_info)
                _company_info_field.forEach(_field => { 
                    if (!_company_info_exist_keys.includes(_field)) {
                        _company_info[_field] = " - "
                    }
                });

                return _company_info
            }
        },
        assessmentInfo () {
            let { service_type, requested_ts, in_progress_ts, in_assessment_ts, duedate_ts, completed_ts  } = this.reportData.info
            service_type = service_type === "일반" ? this.$t("일반 평가", this.report_lang) : this.$t("심화 평가", this.report_lang)

            let _assessmentInfo = {
                service_type: null, requested_date: requested_ts, duedate_date: duedate_ts, completed_date: completed_ts
            }

            if (service_type) _assessmentInfo.service_type = this.$t(service_type, this.report_lang)

            // 평가기간 실 평가기간으로 교체
            if (this.set_actual_duration) {
                _assessmentInfo.requested_date = this.report_lang === 'ko'
                    ? dayjs(in_progress_ts).format('YYYY년 MM월 DD일')
                    : dayjs(in_progress_ts).format('MM/DD/YYYY')

                _assessmentInfo.duedate_date = this.report_lang === 'ko'
                    ? dayjs(in_assessment_ts).format('YYYY년 MM월 DD일')
                    : dayjs(in_assessment_ts).format('MM/DD/YYYY')
            } else {
                if (_assessmentInfo.requested_date) {
                    _assessmentInfo.requested_date = this.report_lang === 'ko'
                        ? dayjs('2024-03-29').format('YYYY년 MM월 DD일')
                        : dayjs('2024-03-29').format('MM/DD/YYYY')
                } else {
                    _assessmentInfo.requested_date = " - "
                }
    
                if (_assessmentInfo.duedate_date) {
                    _assessmentInfo.duedate_date = this.report_lang === 'ko'
                        ? dayjs(_assessmentInfo.duedate_date).format('YYYY년 MM월 DD일')
                        : dayjs(_assessmentInfo.duedate_date).format('MM/DD/YYYY')
                } else {
                    _assessmentInfo.duedate_date = " - "
                }
    
                if (_assessmentInfo.completed_date) {
                    _assessmentInfo.completed_date = this.report_lang === 'ko'
                        ? dayjs(_assessmentInfo.completed_date).format('YYYY년 MM월 DD일')
                        : dayjs(_assessmentInfo.completed_date).format('MM/DD/YYYY')
                } else {
                    _assessmentInfo.completed_date = dayjs().format(this.report_lang === 'ko' ? 'YYYY년 MM월 DD일' : 'MM/DD/YYYY')   
                }
            }

            return _assessmentInfo
        },
        evaluation_score_description () {
            return {
                "ko": `${this.companyInfo['회사명']} 의 ${this.cover_title} 총점은 ${this.roundToOneDecimalPlace(this.scoringInfo.total['환산_점수'])} 점 입니다.`,
                "en": `The total score of the ${this.cover_title} for ${this.companyInfo['회사명']} is ${this.roundToOneDecimalPlace(this.scoringInfo.total['환산_점수'])} points.`,
                "ca": `${this.companyInfo['회사명']} 在 ${this.cover_title}中的总分为 ${this.roundToOneDecimalPlace(this.scoringInfo.total['환산_점수'])} 分。`
            }
        },
        category1_description () {
            return {
                "환경경영": this.$t("환경경영 평가는 환경정책을 수립하고 이에 따른 실천 목표와 세부 계획을 제시하고 있는지, 에너지 사용 및 온실가스 배출량 감축 등 성과를 주기적으로 모니터링하고 보고하는지 확인합니다.", this.report_lang),
                "인권경영": this.$t("인권경영 평가는 조직이 근로시간 관리, 차별 및 직장 내 괴롭힘 방지, 아동노동 및 강제노동 금지 등 인권을 보장하고 있는지, 또한 복지 및 역량강화 기회 등을 제공하고 있는지 확인합니다.", this.report_lang),
                "윤리경영": this.$t("윤리경영 평가는 기업이 투명하고 윤리적인 경영체계를 구축하고, 부패나 뇌물수수, 반경쟁 행위 등 비윤리적 행위를 관리·감독하며, 재발 방지를 위한 조치를 취하고 있는지 확인합니다.", this.report_lang),
                "안전보건경영": this.$t("안전보건경영 평가는 기업이 산업재해 예방, 안전보건 교육, 작업장 위험성 평가 등을 통해 안전 리스크를 줄이고, 임직원의 건강과 복지 증진 활동을 체계적으로 추진하고 있는지 확인합니다.", this.report_lang)
            }
        },
        scoringInfo () {
            let _total_score = this.scoring.total_scoring_pd[0]
            _total_score["환산_점수"] = this.roundToOneDecimalPlace(_total_score["환산_점수"])

            let _category1_score = []
            if (this.scoring?.category1_scoring_pd) {
                _category1_score = this.scoring?.category1_scoring_pd.reduce((_category1_score, _category1) => {
                    const _question_name = this.report_lang === 'ko'
                        ? _category1["category1_question_name"]
                        : this.report_lang === 'en'
                            ? _category1["category1_question_name_ea"]
                            : _category1["category1_question_name_ca"]
                            
                    _category1_score.push({ 
                        question_name: _question_name,
                        question_name_ko: _category1["category1_question_name"],
                        "문항_수": _category1["문항 수"] || 0,
                        "배점": _category1["배점"] || 0,
                        "배점_대비_점수_백분율": _category1["배점_대비_점수_백분율"] || 0,
                        "배점_합": _category1["배점_합"] || 0,
                        "가중치": this.roundToOneDecimalPlace(_category1["가중치"] || 0),
                        "접수_합": this.roundToOneDecimalPlace(_category1["score"] || 0),
                        "환산_점수": this.roundToOneDecimalPlace(_category1["환산_점수"] || 0)
                   })
                    return _category1_score
                }, [])
            }

            let _category3_score = []
            if (this.scoring?.category3_scoring_pd) {
                _category3_score = this.scoring?.category3_scoring_pd.reduce((_category3_score, _category3) => {
                    const _category3_sub_scoring = this.reportData.scoring.sub_scoring_pd.filter((_category3_sub) => _category3_sub.category3_question_code === _category3.category3_question_code)
                    
                    let _is_category3_na = false
                    if (_category3_sub_scoring.length) {
                        _is_category3_na = _category3_sub_scoring.every(({ not_applicable }) => not_applicable === true)
                    }

                    if (!_category3_score[_category3.category1_question_name]) {
                        const _category3_category1_score = this.scoring?.category1_scoring_pd.find(({ category1_question_name }) => category1_question_name === _category3.category1_question_name)
                        // let { category1_question_code, category1_question_name, category1_question_name_ca, category1_question_name_ea, not_applicable_num, 환산_점수 } = _category3
                        let { category1_question_code, category1_question_name, category1_question_name_ca, category1_question_name_ea } = _category3
                        환산_점수 = _is_category3_na ? null : this.roundToOneDecimalPlace(환산_점수 || 0)
                        
                        _category3_score[_category3.category1_question_name] = {
                            category1_question_code,
                            category1_question_name_ko: category1_question_name,
                            category1_question_name: this.report_lang === "ko"
                                ? category1_question_name
                                : this.report_lang === "ca" ? category1_question_name_ca : category1_question_name_ea,
                            category1_score: this.roundToOneDecimalPlace(_category3_category1_score["환산_점수"]),
                            min: this.roundToOneDecimalPlace(_category3_category1_score["환산_점수"]),
                            max: null,
                            category3: []
                        }
                    }

                    let {
                        category3_question_code, category3_question_name, category3_question_name_ca, category3_question_name_ea, 환산_점수
                    } = _category3

                    if (!_is_category3_na) {
                        환산_점수 = this.roundToOneDecimalPlace(환산_점수)
                        if (환산_점수 > 0) {
                            _category3_score[_category3.category1_question_name]["max"] = Math.max(_category3_score[_category3.category1_question_name]["max"], 환산_점수)
                        }
                        // _category3_score[_category3.category1_question_name]["max"] = Math.max(_category3_score[_category3.category1_question_name]["max"], 환산_점수)
                        _category3_score[_category3.category1_question_name]["min"] = Math.min(_category3_score[_category3.category1_question_name]["min"], 환산_점수)
                    }
                    
                    _category3_score[_category3.category1_question_name].category3.push({
                        category3_question_code,
                        category3_question_name: this.report_lang === "ko"
                            ? category3_question_name
                            : this.report_lang === "ca" ? category3_question_name_ca : category3_question_name_ea,
                        score: _is_category3_na ? null : this.roundToOneDecimalPlace(환산_점수 || 0),
                        not_applicable: _is_category3_na
                    })
                    return _category3_score
                }, {})
                
                Object.values(_category3_score).forEach((_category3_group) => {
                    _category3_group.min = _category3_group.max === _category3_group.min ? null : _category3_group.min
                    _category3_group.category3.forEach(category3_ele => {
                        category3_ele.max = category3_ele.score === _category3_group.max
                        category3_ele.min = category3_ele.score === _category3_group.min
                    })

                    _category3_group.min = _category3_group.min === null ? ' - ' : _category3_group.min
                })
            }
            
            return {
                total: _total_score,
                category1: _category1_score,
                category3: Object.values(_category3_score),
            }
        },
        par_score_analytics_guide_text () {
            const _converted_score_p = this.roundToOneDecimalPlace(this.scoring.par_scoring_pd.total_scoring_pd['P']['converted_score'])
            const _converted_score_a = this.roundToOneDecimalPlace(this.scoring.par_scoring_pd.total_scoring_pd['A']['converted_score'])
            const _converted_score_r = this.roundToOneDecimalPlace(this.scoring.par_scoring_pd.total_scoring_pd['R']['converted_score'])
            return {
                "ko": `'정책' 유형은 ${_converted_score_p} 점, '조치' 유형은 ${_converted_score_a}점, '보고' 유형은 ${_converted_score_r} 점 입니다.`,
                "en": `'Policy' type score is ${_converted_score_p}, 'Action' type score is ${_converted_score_a}, and 'Reporting' type score is ${_converted_score_r}.`,
                "ca": `‘政策’类型的分数为${_converted_score_p}分，‘措施’类型的分数为${_converted_score_a}分，‘报告’类型的分数为${_converted_score_r}分。`,
            }
        },
        keyFigureSatifiedInfo () {
            let _keyfigure_satisfied_result = {}
            const _keyfigure_name_subCodes = {
                "SBTi": "Q1.1", "이니셔티브": "Q1.1", "윤리경영인증": "Q1.8", "정보보안인증": "Q1.16",
                "근로손실재해율": "Q3.6", "안전보건인증": "Q3.7",
                "환경/에너지경영시스템": "Q4.3", "CDP": "Q4.5",
                "온실가스_기타_간접_Scope3": "Q4.10", "온실가스_직접_Scope1": "Q4.11", "온실가스_간접_Scope2": "Q4.12",
                "에너지 사용량": "Q4.13",
                "일반 폐기물 배출량": "Q4.18", "유해 폐기물 배출량": "Q4.19",
                "용수 취수량": "Q4.26", "NOx(질소산화물) 배출량": "Q4.52", "SOx(황산화물) 배출량": "Q4.53", "먼지(PM) 배출량": "Q4.54"
            }

            for (const [_keyfigure_name, _keyfigure_sub_code] of Object.entries(_keyfigure_name_subCodes)) {
                if ('SBTi' === _keyfigure_name) {
                    const _subs_evaluations = this.reportData.scoring.scoring_pd.filter(({ sub_code, ev_name }) => sub_code === _keyfigure_sub_code && ev_name.includes(_keyfigure_name))
                    if (!_subs_evaluations.length) {
                        _keyfigure_satisfied_result[_keyfigure_name] = false    
                    } else {
                        _keyfigure_satisfied_result[_keyfigure_name] = _subs_evaluations[0].satisfied
                    }
                } else {
                    const _keyFigure_subs_scoring = this.reportData.scoring.sub_scoring_pd.find(({ sub_code }) => sub_code === _keyfigure_sub_code)
                    if (_keyFigure_subs_scoring) {
                        _keyfigure_satisfied_result[_keyfigure_name] = _keyFigure_subs_scoring.satisfied_num > 0
                    } else {
                        _keyfigure_satisfied_result[_keyfigure_name] = false
                    }   
                }
            }

            return _keyfigure_satisfied_result
        },
        keyFigureInfo_greengas () {
            if (!this.reportData?.parser.values.length) {
                return {
                    "3년간 온실가스 직접 배출량(Scope 1)": null,
                    "3년간 온실가스 간접 배출량(Scope 2)": null,
                    "온실가스 기타 간접 배출량(Scope 3)": null,
                }
            } else {
                const _key_figure_field = ["3년간 온실가스 직접 배출량(Scope 1)", "3년간 온실가스 간접 배출량(Scope 2)", "온실가스 기타 간접 배출량(Scope 3)"]
                const _key_figure_satisfied_field = ["온실가스_직접_Scope1", "온실가스_간접_Scope2", "온실가스_기타_간접_Scope3"]
                const _key_fugure_greengas = [ ...this.reportData?.parser.values ].reduce((_info, _value) => {
                    if (_key_figure_field.includes(_value.criteria_name)) {
                        const _key_figure_field_index = _key_figure_field.findIndex(_field => _field === _value.criteria_name)
                        let _criteria_value = null
                        if (_value.value.length && this.keyFigureSatifiedInfo[_key_figure_satisfied_field[_key_figure_field_index]]) {
                            _criteria_value = { theme: _value.theme, unit: _value.unit, value: _value['key_value'] }
                            _criteria_value['value'] = _criteria_value['value'].reduce((_value_obj, _value_ele) => {
                                _value_obj[_value_ele.key] = _value_ele.value
                                return _value_obj
                            }, {})
                        }

                        _info[_value.criteria_name] = _criteria_value
                    }

                    return _info
                }, {})

                _key_figure_field.forEach(_field => {
                    if (!_key_fugure_greengas[_field]) _key_fugure_greengas[_field] = null
                })

                return _key_fugure_greengas
            }
        },
        keyFigureInfo_LTIFR () {
            const _key_fugure_LTIFR = { "근로손실재해율(LTIFR)": null }
            if (!this.reportData?.parser.values.length || !this.keyFigureSatifiedInfo["근로손실재해율"]) {
                return _key_fugure_LTIFR
            } else {
                
                const _key_figure_LTIFR = [ ...this.reportData?.parser.values ].find(({ criteria_name }) => criteria_name === "근로손실재해율(LTIFR)")
                if (!_key_figure_LTIFR) {
                    return _key_fugure_LTIFR
                } else {
                    if (_key_figure_LTIFR.key_value.length) {
                        _key_fugure_LTIFR["근로손실재해율(LTIFR)"] = {}
                        _key_figure_LTIFR.key_value.forEach(_value_ele => {
                            _key_fugure_LTIFR["근로손실재해율(LTIFR)"][_value_ele.data_year] = _value_ele.value
                        });

                        return _key_fugure_LTIFR
                    } else {
                        return _key_fugure_LTIFR
                    }
                }
            }
        },
        keyFigureInfo_certification () {
            const _key_fugure_set = { "CDP": ' - ', "SBTi": ' - ', "윤리경영인증": ' - ', "정보보안인증": ' - ', "안전보건인증": ' - ', "환경/에너지경영시스템": ' - ' }
            if (!this.reportData.parser.values || !this.reportData.parser.values.length) {
                return {
                    "CDP": { status: false, value:  ' - ', },
                    "SBTi": { status: false, value:  ' - ', },
                    "윤리경영인증": { status: false, value:  ' - ', },
                    "정보보안인증": { status: false, value:  ' - ', },
                    "안전보건인증": { status: false, value:  ' - ', },
                    "환경/에너지경영시스템": { status: false, value:  ' - ' }
                }
            } else {
                const _key_figure_field = Object.keys(_key_fugure_set)
                const _key_fugure_certi = [ ...this.reportData?.parser.values ].reduce((_info, _value) => {
                    let _criteria_name = _value.criteria_name.split('_')[0]
                    if (["정보보안인증", "안전보건인증", "윤리경영인증", "환경/에너지경영시스템", "CDP", "SBTi"].includes(_criteria_name)) {
                        if (["정보보안인증", "안전보건인증", "윤리경영인증", "환경/에너지경영시스템"].includes(_criteria_name)) {
                            let _row_index = _value.criteria_name.split('_')[2]
                            if (!_info[_criteria_name]) _info[_criteria_name] = []
                            if (_value.key_value.length) {
                                _value.key_value.forEach((_ele_value) => {
                                    if (!_info[_criteria_name][_row_index]) {
                                        _info[_criteria_name].splice(_row_index, 0, {})
                                    }

                                    _info[_criteria_name][_row_index] = {
                                        ..._info[_criteria_name][_row_index],
                                        [_ele_value.key]: !this.keyFigureSatifiedInfo[_criteria_name] ? ' - ' : _ele_value.value || ' - '
                                    }
                                });
                            }
                        } else if (['CDP', 'SBTi'].includes(_value.criteria_name)) {
                            if (this.keyFigureSatifiedInfo[_value.criteria_name] && _value.value.length) {
                                _info[_criteria_name] = _value.value
                            }
                        }
                    }

                    return _info
                }, {})

                _key_figure_field.forEach(_field => {
                    if (!_key_fugure_certi[_field]) {
                        _key_fugure_certi[_field] = {
                            status: this.keyFigureSatifiedInfo[_field],
                            value: ' - '
                        }
                    } else {
                        let _key_fugure_certification = null
                        if (_field === "CDP") {
                            _key_fugure_certi['CDP'] = {
                                status: this.keyFigureSatifiedInfo['CDP'] || _key_fugure_certi['CDP'].includes('Climate Change'),
                                value: _key_fugure_certi['CDP']
                            }
                        } else if (_field === "SBTi") {
                            _key_fugure_certi['SBTi'] = {
                                    status: this.keyFigureSatifiedInfo['SBTi'] || _key_fugure_certi['SBTi'].includes('SBTi(과학 기반 감축목표 이니셔티브)'),
                                    value: _key_fugure_certi['SBTi'].includes('SBTi(과학 기반 감축목표 이니셔티브)') ? this.$t('보유', this.report_lang) : ' - '
                                }
                        } else if (["정보보안인증", "안전보건인증", "윤리경영인증", "환경/에너지경영시스템"].includes(_field)) {
                            _key_fugure_certification = _key_fugure_certi[_field].splice(0, 1).reduce((_string_value, _data) => {
                                if (_data["인증명"] && _data["인증범위"] && _data["유효기간"]) {
                                    _string_value += `${_data["인증명"]} (${_data["유효기간"]})`
                                } else if (_data["인증명"] || _data["인증범위"] || _data["유효기간"]) {
                                    _string_value +=`${_data["인증명"] || _data["인증범위"]}`

                                    if (_data["유효기간"]) {
                                        _string_value += ` (${_data["유효기간"]})`
                                    }
                                }

                                return _string_value
                            }, '')

                            _key_fugure_certi[_field] = {
                                status: this.keyFigureSatifiedInfo[_field],
                                value: _key_fugure_certification
                            }
                        }
                    }
                })

                return _key_fugure_certi
            }
        },
        keyFigureInfo_environment () {
            const _empty_value = { FY2021: ' - ', FY2022: ' - ', FY2023: ' - '}
            const _key_fugure_field_set = {
                "일반 폐기물 배출량": { theme:"num", unit:"ton", value: _empty_value },
                "유해 폐기물 배출량": { theme:"num", unit:"ton", value: _empty_value },
                "용수 취수량": { theme:"num", unit:"ton", value: _empty_value },
                "NOx(질소산화물) 배출량": { theme:"num", unit:"ton", value: _empty_value },
                "SOx(황산화물) 배출량": { theme:"num", unit:"ton", value: _empty_value },
                "먼지(PM) 배출량": { theme:"num", unit:"ton", value: _empty_value },
                "에너지 사용량": { theme:"num", unit: "MWh", value: _empty_value }
            }

            if (!this.reportData?.parser.values.length) {
                return _key_fugure_field_set
            } else {
                const _key_figure_field = Object.keys(_key_fugure_field_set)
                const _key_fugure_env = [ ...this.reportData?.parser.values ].reduce((_info, _value) => {
                    if (_key_figure_field.includes(_value.criteria_name)) {
                        let _criteria_value = null
                        if (this.keyFigureSatifiedInfo[_value.criteria_name] && _value.key_value.length) {
                            _criteria_value = { theme: _value.theme, unit: _value.unit, value: _value['key_value'] }
                            _criteria_value['value'] = _criteria_value['value'].reduce((_value_obj, _value_ele) => {
                                _value_obj[_value_ele.key] = _value_ele.value
                                return _value_obj
                            }, {})
                        } else {
                            _criteria_value = { ..._key_fugure_field_set[_value.criteria_name] }
                        }

                        
                        _info[_value.criteria_name] = _criteria_value
                    } else {
                        _info[_value.criteria_name] = { ..._key_fugure_field_set[_value.criteria_name] }
                    }

                    return _info
                }, {})


                _key_figure_field.forEach(_key_name => {
                    if (!_key_fugure_env[_key_name]) _key_fugure_env[_key_name] = null
                })

                return _key_fugure_env
            }
        },
    },
    watch: {},
    created () {},
    methods: {
        async createSummaryPage_v4 (doc, position_y) {
            position_y = this.firstElementSpacing
            position_y = this.addTitle(doc, position_y, 1, "ESG 평가 결과 요약")

            // 기업정보 섹션
            position_y = this.addTitle(doc, position_y, 2, "기업 정보", { skip_divider: true, no_padding: true, no_margin: true })
            let _column_width = this.pageContentWidth / 4
            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: this.jsPDFOpt.margin,
                // styles: this.jsPDFOpt.tableOpt.common,
                styles: this.tableStyles.global,
                body: [
                    [
                        { content: this.$t('기업명', this.report_lang), styles: { ...this.tableStyles.th, cellWidth: _column_width } },
                        { content: this.companyInfo['회사명'], styles: { ...this.tableStyles.td, cellWidth: _column_width } },
                        { content: this.$t('업체코드', this.report_lang), styles: { ...this.tableStyles.th, cellWidth: _column_width } },
                        { content: this.headerInfo.vendor_code, styles: { ...this.tableStyles.td, cellWidth: _column_width } }
                    ],
                    [
                        { content: this.$t('소재국가', this.report_lang), styles: { ...this.tableStyles.th, cellWidth: _column_width } },
                        { content: this.companyInfo['소재국가'], colSpan: 3, styles: { ...this.tableStyles.td, cellWidth: _column_width } }
                    ],
                    [
                        { content: this.$t('매출액', this.report_lang), styles: { ...this.tableStyles.th, cellWidth: _column_width } },
                        { content: `${this.formatNumber(this.companyInfo["매출액"])} (${this.companyInfo["매출액_구분"]})`, styles: { ...this.tableStyles.td, cellWidth: _column_width } },
                        { content: this.$t('근로자수', this.report_lang), styles: { ...this.tableStyles.th, cellWidth: _column_width } },
                        {
                            content: `${this.$t('정규직', this.report_lang)}: ${this.formatNumber(this.companyInfo["근로자_정규직"])}, ${this.formatNumber(this.$t('계약직', this.report_lang))}: ${this.companyInfo["근로자_계약직"]}`,
                            colSpan: 1,
                            rowSpan: 1,
                            styles: { ...this.tableStyles.td, cellWidth: _column_width }
                        }
                    ],
                    [
                        { content: this.$t('주요생산품목', this.report_lang), styles: { ...this.tableStyles.th, cellWidth: _column_width } },
                        { content: this.companyInfo["주요생산품목"], colSpan: 3, styles: { ...this.tableStyles.td, cellWidth: _column_width } }
                    ],
                ],
                didDrawCell: (data) => this.jspdf_common_cell_font_convert(data)
            })
            position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs

            // 평가정보 섹션
            position_y = this.addTitle(doc, position_y, 2, this.$t("평가 정보", this.report_lang), { skip_divider: true, no_padding: true, no_margin: true })
            let _column_width_1 = _column_width
            let _column_width_2 = this.pageContentWidth - _column_width_1
            let _assessment_info_table_body = [
                [
                    { content: this.$t('평가기간', this.report_lang), styles: { ...this.tableStyles.th, cellWidth: _column_width_1 } },
                    { content:  `${this.assessmentInfo.requested_date} ~ ${this.assessmentInfo.duedate_date}`, styles: { ...this.tableStyles.td, cellWidth: _column_width_2 } }
                ]
            ]

            if ((this.assessmentType && this.assessmentType === "OSIS") || (!this.assessmentType && this.reportData.info.service_type === "심화")) {
                _assessment_info_table_body.push(
                    [
                        { content: this.$t('평가유형', this.report_lang), styles: { ...this.tableStyles.th, cellWidth: _column_width_1 } },
                        { content:  this.$t("실사평가", this.report_lang), styles: { ...this.tableStyles.td, cellWidth: _column_width_2 } }
                    ]
                )
            }

            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: this.jsPDFOpt.margin,
                styles: this.tableStyles.global,
                body: _assessment_info_table_body
            })
            position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs
            position_y = this.addTitle(doc, position_y, 2, this.$t("평가결과", this.report_lang))

            // this.setFont(doc, 'table_td', null, 'semibold')
            this.setFont(doc, 'table_td', null, 'semibold')
            if (this.report_lang === "en") {
                doc.setFontSize(13.5)
                // doc.setFontSize(15)
            } else {
                doc.setFontSize(15)
                // doc.setFontSize(15)
            }
            const _total_score_guide_box_padding = 10
            const _total_score_guide_box_width = this.pageContentWidth - this.jsPDFOpt.margin.left
            let _total_score_guide_text = this.evaluation_score_description[this.report_lang]
            _total_score_guide_text = doc.splitTextToSize(_total_score_guide_text, _total_score_guide_box_width - (_total_score_guide_box_padding * 2))
            const _total_score_guide_dim = doc.getTextDimensions(_total_score_guide_text)
            const _total_score_guide_box_height = _total_score_guide_dim.h + (_total_score_guide_box_padding * 2)
            
            doc.setFillColor(...this.jsPDFOpt.card.fillColor)
            doc.setLineWidth(1.5)
            doc.setDrawColor(this.jsPDFOpt.card.borderColor)
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, _total_score_guide_box_height, 'FD')

            const _total_score_guide_text_position_x = this.jsPDFOpt.margin.left + _total_score_guide_box_padding
            const _total_score_guide_text_position_y = position_y + ((_total_score_guide_box_height - _total_score_guide_dim.h) /2) + (_total_score_guide_box_padding / 2)
            doc.text(_total_score_guide_text, _total_score_guide_text_position_x, _total_score_guide_text_position_y, { baseline: 'middle' })
            position_y += _total_score_guide_box_height + this.jsPDFOpt.spacing.section_sm
            
            // ESG 평가 총점
            position_y = this.addTitle(doc, position_y, 3, this.$t("ESG 평가 총점", this.report_lang), { skip_divider: true, no_margin: true })

            // 스코어박스 섹션
            const scorebox_height = this.report_lang === 'ko' ? 70 : 55
            doc.setLineWidth(this.jsPDFOpt.card.lineWidth);
            doc.setDrawColor(this.jsPDFOpt.card.borderColor)
            doc.setFillColor(...this.jsPDFOpt.card.fillColor)
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, scorebox_height, 'FD')
            position_y += scorebox_height

            // 스코어박스 - 스코어 라벨(Total Score)
            if (this.report_lang === "ca") {
                doc.setFont(this.jsPDFOpt.fontFamily_ca, "normal")
            } else {
                doc.setFont(this.jsPDFOpt.fontFamily, "normal")
            }

            doc.setFontSize(9.3)
            const _score_title_position_x = this.jsPDFOpt.margin.left + 10
            const _score_title_position_y = (position_y - scorebox_height + 0.75) + this.jsPDFOpt.margin.top * 0.9
            doc.text( this.report_lang === "ca" ? "总分" : "Total Score", _score_title_position_x, _score_title_position_y)


            // 스코어박스 - 스코어(점수)
            const total_score_width = this.pageContentWidth * 0.4
            this.setFont(doc, 'cover_company_name')
            doc.setFontSize(30)
            
            const _score = this.scoringInfo.total['환산_점수']
            const _score_text = this.report_lang !== 'ko' ? _score.toString() : `${_score} 점`
            const _score_score = doc.splitTextToSize(_score_text, total_score_width);
            const _score_score_dim = doc.getTextDimensions(_score_score);
            const _score_position_x = _score_title_position_x + (((total_score_width - _score_title_position_x) - _score_score_dim.w) / 2)
            doc.text(_score_score, _score_position_x, position_y - (scorebox_height / 2) + (_score_score_dim.h / 2), { halign: 'center' });
            

            // 스코어박스 - 스코어바
            const scorebar_width = this.pageContentWidth * 0.6
            const scorebar_height = 12
            const scorebar_radius = 6
            const scorebar_position_x = this.pageContentWidth * 0.425
            const scorebar_position_y = position_y - (scorebox_height / 2) - (scorebar_height / 2)

            doc.setLineWidth(0);
            doc.setFillColor(228, 220, 211)
            doc.setDrawColor('#d6cdc4')
            doc.roundedRect(scorebar_position_x, scorebar_position_y, scorebar_width, scorebar_height, scorebar_radius, scorebar_radius, 'FD')

            // Draw the marker triangle
            const markerX = scorebar_position_x + ((_score / 100) * scorebar_width);
            doc.setFillColor(0, 0, 0);
            doc.triangle(markerX - 3, scorebar_position_y - 8, markerX + 3, scorebar_position_y - 8, markerX, scorebar_position_y - 3, 'F');

            // Draw the progress bar
            doc.setFillColor(0, 105, 177);
            doc.roundedRect(scorebar_position_x, scorebar_position_y, (_score / 100) * scorebar_width, scorebar_height, 5, 5, 'F');

            // Draw the Step Number
            doc.setFontSize(10);
            doc.setTextColor('#666666')
            doc.text('0', scorebar_position_x, scorebar_position_y - 7);
            const _score_100_width = doc.getStringUnitWidth('100') * doc.getFontSize();
            doc.text('100', scorebar_position_x + scorebar_width - _score_100_width / 2, scorebar_position_y - 7);

            doc.setFontSize(9);
            doc.setTextColor('#999999')
            for (let i = 10; i < 100; i += 10) {
                doc.text(`${i}`, scorebar_position_x + (i / 100) * scorebar_width, scorebar_position_y + scorebar_height + 11, null, null, 'center');
            }
            position_y += this.jsPDFOpt.spacing.section_md - 5
            
            // ESG 평가 영역별 결과
            position_y = this.addTitle(doc, position_y, 3, this.$t('ESG 평가 영역별 결과', this.report_lang), { footnote: this.$t("(각 영역별 점수는 100점 만점 기준 환산 값)", this.report_lang) })
            
            // ESG 평가 영역별 테이블
            let _category1_score_table_name_head = this.scoringInfo.category1.reduce((_added_category1_name, _category1) => {
                _added_category1_name.push({ content: this.splitByManagement(_category1.question_name), styles: { ...this.tableStyles.th, fontSize: 11 } })
                return _added_category1_name
            }, [])

            let _category1_score_table_rows = [
                [
                    { content: this.$t('영역별 점수', this.report_lang), colSpan: 4, styles: { ...this.tableStyles.th, fontSize: 12 }, minCellHeight: 25  }
                ],
                [..._category1_score_table_name_head]
            ]

            const _total_score_cell_width = 0
            const _category1_score_cell_width = (this.pageContentWidth - _total_score_cell_width) / 4
            const _category1_score_cell_height = this.pageContentHeight - position_y - this.jsPDFOpt.footerHeight
            const _category1_score_chart_height = _category1_score_cell_height * 0.75
            const _category1_score_chart_width = _category1_score_chart_height
            let _category1_score_font_size = Math.min(19, 12 * (_category1_score_chart_height / 53))
            _category1_score_font_size = Math.max(13, _category1_score_font_size)
            
            let _category1_score_table_body = []
            for (const _category1 of this.scoringInfo.category1) {
                if (this.category1PieChartInstance) {
                    this.category1PieChartInstance.destroy()
                    this.category1PieChartInstance = null
                }

                _category1_score_table_body.push({
                    content: this.roundToOneDecimalPlace(_category1["환산_점수"]),
                    category1_cell: true,
                    category1_score: this.roundToOneDecimalPlace(_category1["환산_점수"]),
                    category1_img_url: await this.generateCategory1PieChartInstance([this.roundToOneDecimalPlace(_category1["환산_점수"]), 100 - this.roundToOneDecimalPlace(_category1["환산_점수"])]),
                    category1_question_name: _category1.question_name,
                    styles: {
                        ...this.tableStyles.td,
                        minCellHeight: _category1_score_cell_height,
                        cellWidth: _category1_score_cell_width,
                        valign: 'middle',
                        cellPadding: { top: 3.5 },
                        fontSize:  _category1_score_font_size
                    }
                })
            }

            _category1_score_table_rows.push(_category1_score_table_body)

            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: { ...this.jsPDFOpt.margin, top: 0, left: this.jsPDFOpt.margin.left },
                styles: { ...this.tableStyles.global, halign: 'center' },
                body: _category1_score_table_rows,
                didDrawCell: async (data) => {
                    if (data.cell.raw?.category1_cell && data.cell.raw?.category1_cell === true) {
                        const _category1_score_chart_positon_x = data.cell.x + ((_category1_score_cell_width - _category1_score_chart_width) / 2)
                        const _category1_score_chart_positon_y = data.cell.y + ((_category1_score_cell_height - _category1_score_chart_height) / 2) // + 0.5

                        doc.addImage(data.cell.raw.category1_img_url, 'png', _category1_score_chart_positon_x, _category1_score_chart_positon_y, _category1_score_chart_width, _category1_score_chart_height);
                        if (this.category1PieChartInstance) {
                            this.category1PieChartInstance.destroy()
                            this.category1PieChartInstance = null
                        }
                    }
                }
            })

            position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_md
            return position_y
        },
        generatePartialSummaryPage (doc, position_y) {
            doc.addPage();
            this.addHeader(doc);
            position_y = this.firstElementSpacing

            position_y = this.addTitle(doc, position_y, 1, this.$t('영역별 평가결과 요약', this.report_lang))

            this.setFont(doc, 'table_td', null, 'semibold')
            doc.setFontSize(12)
            let _partial_score_guide_padding = 10
            let _partial_score_guide_text = this.report_lang === "ko"
                ? `${this.companyInfo['회사명']}의 영역별 점수와 세부 항목별 점수는 다음과 같습니다.`
                : this.report_lang === "en"
                    ? `The scores by area and the detailed scores for ${this.companyInfo['회사명']} are as follows.`
                    : `${this.companyInfo['회사명']} 各领域的得分和具体项目的得分如下。`
            _partial_score_guide_text = doc.splitTextToSize(_partial_score_guide_text, this.pageContentWidth - (_partial_score_guide_padding  * 2));
            let _partial_score_guide_text_dim = doc.getTextDimensions(_partial_score_guide_text)
            let _partial_score_guide_card_height = _partial_score_guide_text_dim.h + (_partial_score_guide_padding * 2)

            doc.setLineWidth(1.5)
            doc.setDrawColor(this.jsPDFOpt.card.borderColor)
            doc.setFillColor(...this.jsPDFOpt.card.fillColor)
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, _partial_score_guide_card_height, 'FD')
            
            let _partial_score_guide_text_position_y = position_y + (_partial_score_guide_card_height - _partial_score_guide_text_dim.h) - 1
            doc.text(_partial_score_guide_text, this.jsPDFOpt.margin.left + _partial_score_guide_padding,  _partial_score_guide_text_position_y)

            position_y += _partial_score_guide_card_height + this.jsPDFOpt.spacing.section_md

            // 테이블 범주
            const _fill_color = { min: '#FFF3E0', max: '#d3e4f1', na: '#f8f8f8' }
            let legends_ko = [ "최저점 항목", "최고점 항목", "해당없음, 평가제외" ]
            let _category3_table_legend_ele = (this.pageContentWidth / 3)
            let _longest_legend_position_x = this.report_lang === "ko"
                ? this.jsPDFOpt.margin.left + (this.pageContentWidth / 2) - 30
                : this.jsPDFOpt.margin.left
            let _legend_mark_width = 20
            Object.values(_fill_color).forEach((_fill_color_ele, _fill_color_idx) => {
                this.setFont(doc, 'table_td', null, 'normal')
                doc.setFontSize(9.5)
                let _legend_name = 2 > _fill_color_idx
                    ? `${this.$t(legends_ko[_fill_color_idx], this.report_lang)}, `
                    : this.$t(legends_ko[_fill_color_idx], this.report_lang)
                _legend_name = doc.splitTextToSize(_legend_name, _category3_table_legend_ele)
                let _legend_name_dim = doc.getTextDimensions(_legend_name)
                
                doc.setFillColor(Object.values(_fill_color)[_fill_color_idx])
                doc.rect(_longest_legend_position_x, position_y - 6.6, _legend_mark_width, _legend_name_dim.h, 'F')

                let _legend_name_position_x = _longest_legend_position_x + _legend_mark_width + 2
                doc.text(`: ${_legend_name}`, _legend_name_position_x, position_y)
                _longest_legend_position_x += _legend_mark_width + _legend_name_dim.w + 5 + 8
            });

            position_y += 15

            const _category3_group_left = this.scoringInfo.category3.filter(({ category1_question_name_ko }) => ['윤리경영', '인권경영'].includes(category1_question_name_ko))
            const _category3_group_right = this.scoringInfo.category3.filter(({ category1_question_name_ko }) => ['안전보건경영', '환경경영'].includes(category1_question_name_ko)).reverse()
            let _category3_group_left_postion_y = position_y
            let _category3_group_right_postion_y = position_y

            const returnCellFillColor = (min, max, na) => {
                return na ? _fill_color.na
                    : !min && !max && !na
                        ? null
                        : min
                            ? _fill_color.min 
                            : _fill_color.max
            }

            for (const _category3 of _category3_group_left) {
                const _category3_table_left = this.jsPDFOpt.margin.left

                const { category1_question_name, category1_score } = _category3
                _category3_group_left_postion_y = this.addTitle(doc, _category3_group_left_postion_y, 2, `${category1_question_name}:  ${category1_score} 점 `, { skip_divider: true, no_margin: true })

                const _category3_score_table_body = _category3.category3.map(({ category3_question_name, score, min, max, not_applicable }) => ([
                    { content: category3_question_name, styles: { ...this.tableStyles.td, fillColor: returnCellFillColor(min, max, not_applicable) } },
                    { content: not_applicable ? 'N/A' : score, styles: { ...this.tableStyles.td, fillColor: returnCellFillColor(min, max, not_applicable) } },
                ]))

                _category3_score_table_body.unshift([
                    { content: this.$t("중분류", this.report_lang), styles: this.tableStyles.th },
                    { content: this.$t("점수", this.report_lang), styles: this.tableStyles.th },
                ])

                autoTable(doc, {
                    theme: 'grid',
                    startY: _category3_group_left_postion_y,
                    tableWidth: (this.pageContentWidth / 2) - 5,
                    rowPageBreak: 'auto',
                    margin: { ...this.jsPDFOpt.margin, top: 0, left: _category3_table_left },
                    styles: { ...this.tableStyles.global, halign: 'center' },
                    body: _category3_score_table_body,
                    didDrawPage: (HookData) => {                  
                        this.addHeader(HookData.doc)
                    }
                })

                // _category3_group_left_postion_y = doc.lastAutoTable.finalY + _category1_name_dim.h + this.jsPDFOpt.spacing.section_xs
                _category3_group_left_postion_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs
            }

            const _category3_table_right = (this.pageContentWidth / 2) + 5 + this.jsPDFOpt.margin.left
            for (const _category3 of _category3_group_right) {
                const { category1_question_name, category1_score } = _category3
                let category1_question_name_score = `${category1_question_name}: ${category1_score}`
                if (this.report_lang === "ko") {
                    category1_question_name_score += ` 점`
                }
                _category3_group_right_postion_y = this.addTitle(doc, _category3_group_right_postion_y, 2, category1_question_name_score, { skip_divider: true, no_margin: true, position_x: _category3_table_right })

                const _category3_score_table_body = _category3.category3.map(({ category3_question_name, score, min, max, not_applicable }) => ([
                    { content: category3_question_name, styles: { ...this.tableStyles.td, fillColor: returnCellFillColor(min, max, not_applicable) } },
                    { content: not_applicable ? 'N/A' : score, styles: { ...this.tableStyles.td, fillColor: returnCellFillColor(min, max, not_applicable) } },
                ]))

                _category3_score_table_body.unshift([
                    { content: this.$t("중분류", this.report_lang), styles: this.tableStyles.th },
                    { content: this.$t("점수", this.report_lang), styles: this.tableStyles.th },
                ])

                autoTable(doc, {
                    theme: 'grid',
                    startY: _category3_group_right_postion_y,
                    tableWidth: (this.pageContentWidth / 2) - 5,
                    rowPageBreak: 'auto',
                    margin: { ...this.jsPDFOpt.margin, top: 0, left: _category3_table_right },
                    styles: { ...this.tableStyles.global, halign: 'center' },
                    body: _category3_score_table_body,
                    didDrawPage: (HookData) => {                  
                        this.addHeader(HookData.doc)
                    }
                })

                _category3_group_right_postion_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_xs
            }

            position_y = _category3_group_left_postion_y > _category3_group_right_postion_y ? _category3_group_left_postion_y : _category3_group_right_postion_y
            return position_y
        },
        drawChartCategory1PieImage () {
            let _category1PieChart_url = null
            if (this.category1PieChartInstance) {
                _category1PieChart_url = this.category1PieChartInstance.toBase64Image('image/png', 1)
            }

            return _category1PieChart_url
        },
        generatecategory1AreaChartInstance (_data = this.scoringInfo.category1, opt = {}) {
            return new Promise((resolve) => {
                if (!_data) {
                    _data = this.scoringInfo.category1
                }
                
                let _category1_data = _data.map(({ 환산_점수 }) => 환산_점수)
                let _category1_label = _data.map(({ question_name }) => this.$t(question_name, this.report_lang))
                if (this.report_lang === 'en') {
                    _category1_label = this.splitByManagement(_category1_label)
                }
                
    
                if (!opt.emphasis || typeof opt.emphasis === "undefined") {
                    opt.emphasis = false
                }

                let emphasis_max_label = null
                if (!opt.emphasis_max || typeof opt.emphasis_max === "undefined") {
                    opt.emphasis_max = false
                } else {
                    let _max_score = Math.max(..._category1_data)
                    emphasis_max_label = _data.find(({ 환산_점수 }) => 환산_점수 === _max_score)
                    emphasis_max_label = this.splitByManagement(this.$t(emphasis_max_label.question_name, this.report_lang))
                }
                
                let emphasis_min_label = null
                if (!opt.emphasis_min || typeof opt.emphasis_min === "undefined") {
                    opt.emphasis_min = false
                } else {
                    let _min_score = Math.min(..._category1_data)
                    emphasis_min_label = _data.find(({ 환산_점수 }) => 환산_점수 === _min_score)
                    emphasis_min_label = this.splitByManagement(this.$t(emphasis_min_label.question_name, this.report_lang))
                }
                
    
                const _scope1_data = {
                    labels: _category1_label,
                    datasets: [{
                        data: _category1_data,
                        fill: true,
                        backgroundColor: 'rgba(0, 105, 177, 0.4)',
                        borderColor: 'rgb(0, 105, 177)',
                        pointBorderColor: (context) => {
                            if (opt.emphasis_max) {
                                if (_category1_label[context.index] === emphasis_max_label) {
                                    return 'rgba(0, 105, 177, 1)'
                                }
                            }
                            
                            if (opt.emphasis_min) {
                                if (_category1_label[context.index] === emphasis_min_label) {
                                    return 'rgba(229, 57, 53, 1)'
                                }
                            }

                            if (opt.emphasis) {
                                if (_category1_label[context.index] === opt.emphasis_label) {
                                    return 'rgba(0, 105, 177, 1)'
                                }
                            }

                            return 'rgb(90, 162, 235)';
                        },
                        pointBackgroundColor: (context) => {
                            if (opt.emphasis_max) {
                                if (_category1_label[context.index] === emphasis_max_label) {
                                    return 'rgba(0, 105, 177, 0.6)'
                                }
                            }
                            
                            if (opt.emphasis_min) {
                                if (_category1_label[context.index] === emphasis_min_label) {
                                    return 'rgba(229, 57, 5, 0.6)'
                                }
                            }

                            if (opt.emphasis) {
                                if (_category1_label[context.index] === opt.emphasis_label) {
                                    return 'rgba(0, 105, 177, 0.6)'
                                }
                            }

                            return 'rgba(90, 162, 235, 0.5)';
                        }
                    }]
                }
    
                const _common_option = {
                    global: {
                        aspectRatio: this.report_lang === 'en' ? null : 4.7/3,
                        responsive: false,
                        maintainAspectRatio: false,
                        devicePixelRatio: 1.5,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0,
                            onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    },
                    plugins: {
                        legend: { display: false } ,
                        datalabels: {
                            display: false
                        },
                    },
                    scales: {
                        max: 100,
                        beginAtZero: true,
                        ticks: {
                            display: false
                        }
                    },
                    layout: {}
                }

                let _font_size = {
                    default: this.report_lang === 'en'  ? 12.5 :  14.5,
                    enphasis: this.report_lang === 'en' ? 13.5 : this.report_lang === 'ca' ?  15.5 : 16
                }
    
                const _scope1_area_option = {
                    ..._common_option.global,
                    layout: _common_option.layout,
                    elements: { line: { borderWidth: 1.5 } },
                    scales: {
                        r: {
                            ..._common_option.scales,
                            ticks: {
                                ..._common_option.scales.ticks,
                                stepSize: 25,
                                color: '#E0E0E0',
                                autoSkip: false, // 레이블 건너뛰기 해제
                                overflow: 'hidden' // 레이블이 차트 영역 밖으로 넘치지 않도록 설정
                            },
                            grid: {
                                color: '#E0E0E0'
                            },
                            pointLabels: {
                                display: true,
                                padding: 7,
                                font: {
                                    size: (context) => {
                                        if (opt.emphasis_max) {
                                            if (context.label === emphasis_max_label) {
                                                return _font_size.enphasis
                                            }
                                        }
                                        
                                        if (opt.emphasis_min) {
                                            if (context.label === emphasis_min_label) {
                                                return _font_size.enphasis
                                            }
                                        }
                                        
                                        if (opt.emphasis) {
                                            if (context.label === opt.emphasis_label) {
                                                return _font_size.enphasis
                                            }
                                        }

                                        return _font_size.default;
                                    },
                                    weight: (context) => {
                                        if (opt.emphasis_max) {
                                            if (context.label === emphasis_max_label) {
                                                return 700
                                            }
                                        }
                                        
                                        if (opt.emphasis_min) {
                                            if (context.label === emphasis_min_label) {
                                                return 700
                                            }
                                        }
                                        
                                        if (opt.emphasis) {
                                            if (context.label === opt.emphasis_label) {
                                                return 700
                                            }
                                        }

                                        return 500
                                    },
                                },
                                color: (context) => {
                                    if (opt.emphasis_max) {
                                        if (context.label === emphasis_max_label) {
                                            return 'rgba(0, 105, 177, 1)'
                                        }
                                    }
                                    
                                    if (opt.emphasis_min) {
                                        if (context.label === emphasis_min_label) {
                                            return 'rgba(229, 57, 5, 1)'
                                        }
                                    }

                                    if (opt.emphasis) {
                                        if (context.label === opt.emphasis_label) {
                                            return 'rgba(0, 105, 177, 1)'
                                        }
                                    }

                                    return '#616161';
                                }
                            }
                        }
                    },
                    plugins: _common_option.plugins
                }                
    
                if (!this.category1AreaChartInstance) {
                    this.category1AreaChartInstance = this.$chartjs.createChart(
                        document.getElementById('category1-chart-area'),
                        {
                            type: 'radar',
                            data: _scope1_data,
                            options: _scope1_area_option
                        }
                    )
                } else {
                    this.$chartjs.updateChart(this.category1AreaChartInstance, _scope1_data, _scope1_area_option)
                }
                
            })
        },
        drawChartCategory1Image () {
            const _chart_image = { area: null, bar: null }
            if (this.category1AreaChartInstance) {
                const _category1AreaChart_url = this.category1AreaChartInstance.toBase64Image('image/jpg', 1)
                _chart_image.area = _category1AreaChart_url
            }

            if (this.category1BarChartInstance) {
                const _category1BarChart_url = this.category1BarChartInstance.toBase64Image('image/jpg', 1)
                _chart_image.bar = _category1BarChart_url
            }

            return _chart_image
        },
        generatecategory3BarChartInstance (labels, data) {
            // opt = {}
            return new Promise((resolve) => {
                // const _common_option = {
                //     global: {
                //         // aspectRatio: 5/3,
                //         responsive: false,
                //         maintainAspectRatio: false,
                //         responsiveAnimationDuration: 0,
                //         animation: {
                //             duration: 0,
                //             onComplete: function () {
                //                 resolve(this.toBase64Image('image/jpg', 1));
                //             }
                //         }
                //     },
                //     plugins: {
                //         legend: { display: false },
                //         datalabels: { display: false }
                //     },
                //     scales: {
                //         max: 100,
                //         beginAtZero: true,
                //         ticks: {
                //             display: false
                //         }
                //     }
                // }
    
                const _scope3_data = {
                    labels: labels,
                    datasets: [{
                        label: this.headerInfo?.company_name,
                        data: data,
                        fill: true,
                        backgroundColor: 'rgba(255, 165, 0, 1)',  // 막대 색상 (투명도 없음)
                        borderWidth: 1  // 막대 테두리 두께
                        // backgroundColor: 'rgba(90, 162, 235, 0.3)',
                        // borderColor: 'rgb(90, 162, 235)',
                        // pointBackgroundColor: 'rgb(90, 162, 235)',
                        // barPercentage: 1,
                        // categoryPercentage: this.report_lang === 'en' ? 0.75 : 0.45,
                        // axis: 'y'
                    }]
                }
    
                const _scope3_bar_option = {
                    responsive: false,
                    layout: {
                        padding: {
                            right: 50  // 오른쪽 패딩 추가 (레이블이 잘리지 않도록)
                        }
                    },
                    barThickness: 5,
                    categoryPercentage: 1,  // 카테고리(레이블) 사이의 공간을 설정
                    barPercentage: 1,  // 각 막대가 차지하는 공간 비율 설정
                    responsiveAnimationDuration: 0,
                    animation: {
                        duration: 0,
                        onComplete: function () {
                            resolve(this.toBase64Image('image/jpg', 1));
                        }
                    },
                    indexAxis: 'y',
                    scales: {
                        x: {
                            beginAtZero: true,
                            max: 100,
                            display: false
                        },
                        y: {
                            grid: {
                                display: false  // Y축 그리드 라인 숨김
                            },
                            ticks: {
                                font: {
                                    family: "Noto Sans KR",
                                    // padding: 0,
                                    size: 8,
                                    weight: 'normal',
                                },
                                color: "rgb(71, 71, 71)",
                                padding: 0,
                                autoSkip: false
                            }
                        }
                    },
                    plugins: {
                        // ..._common_option.plugins,
                        datalabels: {
                            display: false,
                            // display: true,
                            // align: 'center',
                            // anchor: 'center',
                            // color: '#575757',
                            // font: {
                            //     size: 14
                            // }
                        },
                        legend: {
                            display: false  // 범례를 숨김
                        }
                    }
                }
    
    
                if (this.category1BarChartInstance) {
                    this.category1BarChartInstance.destroy()
                    this.category1BarChartInstance = null
                }
    
                this.category1BarChartInstance = this.$chartjs.createChart(
                    document.getElementById('category1-chart-bar'),
                    {
                        type: 'bar',
                        data: _scope3_data,
                        options: _scope3_bar_option
                    }
                )
            })
            
            
            // return this.drawChartCategory1Image()
        },
        generatecategory1AreaBarChartInstance (opt = {}) {
            if (!opt.emphasis) {
                opt.emphasis = false
            }

            if (!opt.emphasis_label) {
                opt.emphasis_label = null
            }

            if (!opt.emphasis_value) {
                opt.emphasis_value = null
            }

            let _category1_label = this.scoringInfo.category1.map(({ question_name }) => this.$t(question_name, this.report_lang))
            const _category1_data = this.scoringInfo.category1.map(({ 환산_점수 }) => 환산_점수)
            const _category1_data_max = Math.max.apply(null, _category1_data_max);
            if (this.report_lang === 'en') {
                _category1_label = this.splitByManagement(_category1_label)
            }

            const _scope1_data = {
                labels: _category1_label,
                datasets: [{
                    label: this.headerInfo?.company_name,
                    data: _category1_data,
                    fill: true,
                    backgroundColor: 'rgba(90, 162, 235, 0.3)',
                    borderColor: 'rgb(90, 162, 235)',
                    pointBackgroundColor: 'rgb(90, 162, 235)',
                    barPercentage: 1,
                    categoryPercentage: this.report_lang === 'en' ? 0.75 : 0.45,
                    axis: this.report_lang === 'en' ? 'y' : 'x'
                }]
            }

            const _common_option = {
                global: {
                    aspectRatio: this.report_lang === 'en' ? 5/3 : 4.7/3,
                    responsive: false,
                    maintainAspectRatio: false,
                    responsiveAnimationDuration: 0,
                    animation: { duration: 0 }
                },
                plugins: {
                    legend: { display: false },
                    datalabels: { display: false }
                },
                scales: {
                    max: 100,
                    beginAtZero: true,
                    ticks: {
                        display: false
                    }
                }
            }

            const _scope1_area_option = {
                ..._common_option.global,
                layout: {
                    padding: {
                        top: this.report_lang === 'en' ? 0 : 10,
                        right: 15,
                        bottom: this.report_lang === 'en' ? 0 : 10,
                        left: 15
                    },
                },
                elements: { line: { borderWidth: 1 } },
                scales: {
                    r: {
                        ..._common_option.scales,
                        ticks: {
                            ..._common_option.scales.ticks,
                            stepSize: 25
                        },
                        pointLabels: {
                            display: true,
                            padding: 10,
                            font: {
                                family: "Noto Sans KR",
                                size: 11, // 13,
                                weight: 'normal',
                            },
                            color: "rgb(71, 71, 71)"
                        }
                    }
                },
                plugins: _common_option.plugins
            }

            if (opt.emphasis && opt.emphasis_label) {
                _scope1_area_option.scales.r.ticks.color = (context) => {
                    return context.text === opt.emphasis_label ? 'yellow' : 'black';
                }

            }

            if (opt.emphasis && !opt.emphasis_value) {
                opt.emphasis = false
            }

            const _scope1_bar_option = {
                ..._common_option.global,
                layout: {
                    padding: {
                        top: this.report_lang === "en" ? 5 : Math.max.apply(null, _category1_data) < 80 ? 10 : 34,
                        right: 10,
                        bottom: this.report_lang === "en" ? 5 : Math.max.apply(null, _category1_data) < 80 ? 10 : 15,
                        left: 10,
                    },
                },
                elements: { bar: { borderWidth: 1 } },
                scales: {
                    x: {
                        max: 100,
                        grid: {
                            display: false,
                            drawOnChartArea: false,
                            borderWidth: 1.5
                        },
                        ticks: {
                            stepSize: 25,
                            display: this.report_lang !== 'en',
                            font: {
                                family: "Noto Sans KR",
                                size: 11,
                                weight: 'normal',
                            },
                            color: "rgb(71, 71, 71)"
                        }
                    },
                    y: {
                        ..._common_option.scales,
                        max: this.report_lang === 'en' ? undefined : 100 ,
                        ticks: {
                            display: this.report_lang === 'en',
                            font: {
                                family: "Noto Sans KR",
                                padding: 0,
                                size: 10,
                                weight: 'normal',
                            },
                            color: "rgb(71, 71, 71)",
                            padding: 0,
                            autoSkip: false
                        },
                        grid: {
                            borderWidth: 0,
                            display: false,
                            drawOnChartArea: false
                        }
                    }
                },
                plugins: {
                    ..._common_option.plugins,
                    datalabels: {
                        display: true,
                        // align: 'end',
                        // anchor: 'end',
                        // color: '#575757',
                        // font: {
                        //     size: 11
                        // }
                    }
                }
            }

            if (!this.category1AreaChartInstance) {
                this.category1AreaChartInstance = this.$chartjs.createChart(
                    document.getElementById('category1-chart-area'),
                    {
                        type: 'radar',
                        data: _scope1_data,
                        options: _scope1_area_option
                    }
                )
            } else {
                this.$chartjs.updateChart(this.category1AreaChartInstance, _scope1_data, _scope1_area_option)
            }

            if (this.report_lang === 'en') {
                _scope1_bar_option.indexAxis = 'y'
            } else {
                _scope1_bar_option.indexAxis = 'x'
            }
            
            if (this.category1BarChartInstance) {
                this.category1BarChartInstance.destroy()
                this.category1BarChartInstance = null
            }

            this.category1BarChartInstance = this.$chartjs.createChart(
                document.getElementById('category1-chart-bar'),
                {
                    type: 'bar',
                    data: _scope1_data,
                    options: _scope1_bar_option
                }
            )
            
            return this.drawChartCategory1Image()
        },
        async generateCategory3AnalysisPage (doc, position_y) {
            doc.addPage();
            this.addHeader(doc, 2);
            position_y = this.firstElementSpacing

            // 세부 영역별 평가 결과
            position_y = this.addTitle(doc, position_y, 1, '세부 영역별 평가 결과')

            // 세부 영역별 점수
            for (const [category3_idx, _category3] of this.scoringInfo.category3.entries()) {
                if (category3_idx > 0) {
                    doc.addPage();
                    this.addHeader(doc, 2);
                    position_y = this.firstElementSpacing
                }

                const { category1_question_name, category1_question_name_ko } = _category3
                
                position_y = this.addTitle(doc, position_y, 2, category1_question_name, { skip_divider: true, no_padding: true, })
                // { skip_divider: true }
                position_y -= 5
                position_y = this.addTitle(doc, position_y, 3, "영역별 평가 결과", { skip_divider: true, no_margin: true, no_padding: true })

                const _category3_score_box_padding = 5
                const _category1_score_box_width = this.pageContentWidth
                const _category1_score_box_half_position_y = this.jsPDFOpt.margin.left + ((this.pageContentWidth / 2) - _category3_score_box_padding)
                const _category1_score_box_half_width = ((this.pageContentWidth / 2) - _category3_score_box_padding)
                const _category1_score_box_height = 85 // 90 // 100
                const _category1_score_box_inner_position_y_begin = position_y + _category3_score_box_padding
                const _category1_score_box_inner_position_y_end = _category1_score_box_inner_position_y_begin + _category1_score_box_height - (_category3_score_box_padding * 2)

                doc.setFillColor(...this.jsPDFOpt.card.fillColor);
                doc.setLineWidth(this.jsPDFOpt.card.lineWidth * 2);
                doc.setDrawColor(this.jsPDFOpt.card.borderColor);
                doc.rect(this.jsPDFOpt.margin.left, position_y, _category1_score_box_width, _category1_score_box_height, 'FD')

                doc.setLineWidth(0.75);
                doc.setDrawColor('#E0E0E0');
                doc.line(_category1_score_box_half_position_y, _category1_score_box_inner_position_y_begin, _category1_score_box_half_position_y, _category1_score_box_inner_position_y_end)
                
                const _category3_category1_question_name = doc.splitTextToSize(`${_category3.category1_question_name} ${this.$t('총점', this.report_lang)}`, _category1_score_box_half_width - 10)
                const _category3_category1_question_name_dim = doc.getTextDimensions(_category3_category1_question_name)
                const _category3_category1_question_name_position_x = this.jsPDFOpt.margin.left + 10
                const _category3_category1_question_name_position_y = _category1_score_box_inner_position_y_begin + (_category3_score_box_padding * 2)
                doc.text(_category3_category1_question_name, _category3_category1_question_name_position_x, _category3_category1_question_name_position_y)
                const _category3_category1_question_name_position_y_end = _category3_category1_question_name_position_y + _category3_category1_question_name_dim.h

                doc.setFontSize(30)
                let _category3_category1_question_score = this.report_lang === "ko" ? `${_category3.category1_score} 점` : `${_category3.category1_score}`
                _category3_category1_question_score = doc.splitTextToSize(_category3_category1_question_score, _category1_score_box_half_width)
                const _category3_category1_question_score_dim = doc.getTextDimensions(_category3_category1_question_score)
                const _category3_category1_question_score_position_x = this.jsPDFOpt.margin.left + ((_category1_score_box_half_width - _category3_category1_question_score_dim.w) / 2)
                const _category3_category1_question_score_position_y = _category3_category1_question_name_position_y_end + ((_category1_score_box_inner_position_y_end - _category3_category1_question_name_position_y_end) / 2)
                doc.text(_category3_category1_question_score, _category3_category1_question_score_position_x, _category3_category1_question_score_position_y)

                const _category3_category1_area_chart_height = this.report_lang === "ca"
                    ? _category1_score_box_height * 0.85
                    : _category1_score_box_height * 0.8
                const _category3_category1_area_chart_width = this.report_lang === "ca" || this.report_lang === "ko"
                    ? _category3_category1_area_chart_height * 1.45
                    : _category3_category1_area_chart_height * 1.8

                const _category3_category1_chart_position_x = this.jsPDFOpt.margin.left + _category1_score_box_half_width + ((_category1_score_box_half_width - _category3_category1_area_chart_width) / 2) // + (_category3_score_box_padding * 1)
                const _category3_category1_chart_position_y = _category1_score_box_inner_position_y_begin + ((_category1_score_box_height - _category3_category1_area_chart_height) / 2) - _category3_score_box_padding
                const _cataory1_chart_area = await this.generatecategory1AreaChartInstance(null, { emphasis: true, emphasis_label: this.splitByManagement(category1_question_name).trim() })
                if (this.category1AreaChartInstance) {
                    this.category1AreaChartInstance.destroy()
                    this.category1AreaChartInstance = null
                }
                
                doc.addImage(_cataory1_chart_area, 'png', _category3_category1_chart_position_x, _category3_category1_chart_position_y, _category3_category1_area_chart_width, _category3_category1_area_chart_height);
                position_y += _category1_score_box_height + this.jsPDFOpt.spacing.section_xs - 5

                if (this.checkNeedNewPage(doc, position_y, 100)) {
                    position_y = this.firstElementSpacing
                }

                this.setFont(doc, 'table_td', null)
                doc.setFontSize(10.5)
                const _category1_description_padding = 10
                const _category1_description_text = doc.splitTextToSize(this.category1_description[category1_question_name_ko], this.pageContentWidth - (_category1_description_padding * 2))
                const _category1_description_text_dim = doc.getTextDimensions(_category1_description_text)
                const _category1_description_box_height = _category1_description_text_dim.h + (_category1_description_padding * 2)
                const _category1_description_position_y = position_y + _category1_description_padding * 1.55
                
                doc.setLineWidth(this.jsPDFOpt.card.lineWidth);
                doc.setDrawColor(this.jsPDFOpt.card.borderColor);
                doc.setFillColor(...this.jsPDFOpt.card.fillColor);
                doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, _category1_description_box_height, 'FD')
                doc.text(_category1_description_text, this.jsPDFOpt.margin.left + _category1_description_padding, _category1_description_position_y, { lineHeightFactor: 1.3 })
                position_y += _category1_description_box_height + this.jsPDFOpt.spacing.section_sm

                position_y = this.addTitle(doc, position_y, 3, this.$t("세부 문항별 평가결과", this.report_lang), {
                    skip_divider: true, no_margin: true, footnote: this.report_lang === "ko" ? "중분류 점수는 100 점 만점 기준 환산 값" : null
                })
                const y_axis_line_padding = 4.5
                const _filtered_category3_score = _category3.category3.filter(({ not_applicable }) => not_applicable === false)
                let _category3_score_chart_area_position_x_begin = this.jsPDFOpt.margin.left
                let _category3_score_chart_area_position_x_end = this.jsPDFOpt.margin.left + this.pageContentWidth
                let _category3_score_chart_width = _category3_score_chart_area_position_x_end - _category3_score_chart_area_position_x_begin
                let _category3_score_chart_inner_width = _category3_score_chart_width - (y_axis_line_padding * 4)
                let _category3_score_chart_label_width = _category3_score_chart_inner_width * 0.35
                let _category3_score_chart_label_position_x_begin = _category3_score_chart_area_position_x_begin + (y_axis_line_padding * 2)
                let _category3_score_chart_label_position_x_end = _category3_score_chart_label_position_x_begin + _category3_score_chart_label_width - y_axis_line_padding
                let _category3_score_chart_y_axis_position_x = _category3_score_chart_label_position_x_end + y_axis_line_padding
                let _category3_score_chart_bar_area_width = (_category3_score_chart_inner_width * 0.65) - (y_axis_line_padding * 4)
                let _category3_score_chart_bar_position_x_begin = _category3_score_chart_label_position_x_end + y_axis_line_padding
                let _category3_score_chart_bar_thickness = 6

                let _category3_score_label_total_height = _filtered_category3_score.reduce((_labels_total_height, { category3_question_name }) => {
                    this.setFont(doc, 'table_td', null, 'medium')
                    doc.setFontSize(9.5)
                    const _label = doc.splitTextToSize(category3_question_name, _category3_score_chart_label_width)
                    _labels_total_height += doc.getTextDimensions(_label).h / _label.length
                    return _labels_total_height
                }, 0)

                _category3_score_label_total_height += (_filtered_category3_score.length - 1) * (y_axis_line_padding * 2)

                let _category3_score_chart_area_height = _category3_score_label_total_height + (y_axis_line_padding * 2) // bar 시리즈에 위, 아래 패딩 추가
                let _category3_score_chart_height = _category3_score_chart_area_height + (y_axis_line_padding * 3) // 차트 내부 영역 - 높이에 위, 아래 패딩 추가
                let _category3_score_chart_position_y_begin = position_y
                let _category3_score_chart_area_position_y_begin = _category3_score_chart_position_y_begin + y_axis_line_padding
                let _category3_score_chart_area_position_y_end = _category3_score_chart_area_position_y_begin + _category3_score_chart_area_height + y_axis_line_padding
                
                let _category3_bar_position_y = _category3_score_chart_area_position_y_begin + (y_axis_line_padding * 2.5)
                _filtered_category3_score.forEach(({ category3_question_name, score, not_applicable }) => {
                    // label 추가
                    const _category3_barChart_label = doc.splitTextToSize(category3_question_name, _category3_score_chart_label_width)
                    const _category3_barChart_label_dim = doc.getTextDimensions(_category3_barChart_label)
                    this.setFont(doc, 'table_td', null, 'medium')
                    doc.setFontSize(9.5)

                    if (_category3_barChart_label.length > 1) {
                        doc.text(_category3_barChart_label, _category3_score_chart_label_position_x_end, _category3_bar_position_y - 5, { align: 'right' })
                    } else {
                        doc.text(_category3_barChart_label, _category3_score_chart_label_position_x_end, _category3_bar_position_y, { align: 'right' })
                    }

                    // score bar 추가
                    doc.setFillColor(0, 105, 177);
                    const _category3_barChart_bar_width = not_applicable ? 0 : (score/ 100) * _category3_score_chart_bar_area_width
                    const _category3_barChart_label_height = _category3_barChart_label.length > 1 ? _category3_barChart_label_dim.h * 0.5 : _category3_barChart_label_dim.h
                    const _category3_barChart_bar_position_y = _category3_bar_position_y + (_category3_barChart_label_height - _category3_score_chart_bar_thickness) / 2 - y_axis_line_padding - 0.75
                    const _category3_barChart_bar_position_x_end = _category3_score_chart_bar_position_x_begin + _category3_barChart_bar_width
                    doc.rect(_category3_score_chart_bar_position_x_begin, _category3_barChart_bar_position_y, _category3_barChart_bar_width, _category3_score_chart_bar_thickness, 'F')

                    // score 추가
                    this.setFont(doc, 'table_td', null, 'medium')
                    doc.setFontSize(9.5)
                    const _category3_barChart_score = doc.splitTextToSize(not_applicable ? 'N/A' : score, 30)
                    const _category3_barChart_score_dim = doc.getTextDimensions(_category3_barChart_score)
                    doc.text(_category3_barChart_score, _category3_barChart_bar_position_x_end + y_axis_line_padding, _category3_barChart_bar_position_y + ((_category3_score_chart_bar_thickness + _category3_barChart_score_dim.h) / 2) - 1)
                    _category3_bar_position_y += (y_axis_line_padding * 2) + _category3_barChart_label_height
                })


                // 라벨과 바의 분기 line
                doc.setLineWidth(0.35);
                doc.setDrawColor('#c8c8c8');
                doc.line(_category3_score_chart_y_axis_position_x, _category3_score_chart_area_position_y_begin, _category3_score_chart_y_axis_position_x, _category3_score_chart_area_position_y_end)

                // category3 bar 차트 Area
                doc.setLineWidth(this.jsPDFOpt.card.lineWidth)
                doc.setDrawColor(this.jsPDFOpt.card.borderColor)
                doc.rect(_category3_score_chart_area_position_x_begin, _category3_score_chart_position_y_begin, _category3_score_chart_width, _category3_score_chart_height, 'D')

                if (this.report_lang !== "ko") {
                    this.setFont(doc, 'footnote')
                    const _category3_barChart_footnote = doc.splitTextToSize(this.$t('중분류 점수는 100 점 만점 기준 환산 값', this.report_lang), this.pageContentWidth)
                    const _category3_barChart_footnote_dim = doc.getTextDimensions(_category3_barChart_footnote)
                    const _category3_barChart_footnote_position_y = _category3_score_chart_position_y_begin + _category3_score_chart_height + _category3_barChart_footnote_dim.h + 5
                    
                    // doc.setFontSize(9.5)
                    doc.text(_category3_barChart_footnote, this.jsPDFOpt.margin.left + this.pageContentWidth, _category3_barChart_footnote_position_y, { align: 'right' })
                    position_y += _category3_barChart_footnote_dim.h + 5
                }

                position_y += _category3_score_chart_height + this.jsPDFOpt.spacing.section_md
                if (this.checkNeedNewPage(doc, position_y, 30)) {
                    position_y = this.firstElementSpacing
                } else {
                    // position_y -= 3
                }

                // 핵심지표 결과 테이블 범주
                const _fill_color = { "충족": '#0069aa', "일부항목 충족": '#fa7e14', "미충족": '#dc353c', "해당없음": '#BDBDBD' }
                let _category3_table_legend_ele = (this.pageContentWidth / 3)
                let legends_ko = [ "충족", "일부항목 충족", "미충족", '해당없음' ]
                let _longest_legend_position_x_weight = {
                    ko: 28,
                    en: 0,
                    ca: 40
                }
                let _longest_legend_position_x = this.jsPDFOpt.margin.left + (this.pageContentWidth / 2) + _longest_legend_position_x_weight[this.report_lang]
                let _legend_mark_width = 7
                let _legend_mark_position_y = position_y + 1
                Object.values(_fill_color).forEach((_fill_color_ele, _fill_color_idx) => {
                    this.setFont(doc, 'table_td', null, 'normal')
                    doc.setFontSize(9)
                    let _legend_name = 3 > _fill_color_idx
                        ? `${this.$t(legends_ko[_fill_color_idx], this.report_lang)}, `
                        : this.$t(legends_ko[_fill_color_idx], this.report_lang)
                    _legend_name = doc.splitTextToSize(_legend_name, _category3_table_legend_ele)
                    let _legend_name_dim = doc.getTextDimensions(_legend_name)
                    
                    doc.setFillColor(Object.values(_fill_color)[_fill_color_idx])
                    doc.circle(_longest_legend_position_x, _legend_mark_position_y, 3, 'F')

                    let _legend_name_position_x = _longest_legend_position_x + _legend_mark_width - 1
                    doc.text(`: ${_legend_name}`, _legend_name_position_x, _legend_mark_position_y + 2)
                    _longest_legend_position_x += _legend_mark_width + _legend_name_dim.w + 5 + 5
                });

                
                position_y = this.addTitle(doc, position_y - 5, 3, this.$t("핵심지표 결과", this.report_lang), { skip_divider: true, no_margin: true })
                let _category1_key_indicator = this.scoring?.category1_importance_pd
                    .filter(({ category1_question_code }) => category1_question_code === _category3.category1_question_code
                )
                _category1_key_indicator = _category1_key_indicator.reduce((_key_indicators, _key_indicator) => {
                    let {
                        category3_question_code, category3_question_name, category3_question_name_ca, category3_question_name_ea,
                        sub_code, sub_name, sub_name_ca, sub_name_ea, level
                    } = _key_indicator

                    if (sub_code === "Q4.12") {
                        sub_name = "최근 3년간 온실가스 간접 배출량(Scope 2) 관리 및 공개 여부"
                        sub_name_ca = "过去3年间接温室气体排放（范围2）的管理和公开情况"
                        sub_name_ea = "Management and disclosure of indirect greenhouse gas emissions (Scope 2) over the past 3 years"
                    }
                    
                    let _category3_question_name = this.report_lang === "ko"
                        ? category3_question_name
                        : this.report_lang === "ca" ? category3_question_name_ca : category3_question_name_ea

                    let _sub_name = this.report_lang === "ko"
                        ? sub_name
                        : this.report_lang === "ca" ? sub_name_ca : sub_name_ea

                    
                    if (!_key_indicators[category3_question_code]) {
                        _key_indicators[category3_question_code] = {
                            category3_question_name: _category3_question_name,
                            count: 0,
                            indicators: []
                        }
                    }

                    _key_indicators[category3_question_code].count++
                    _key_indicators[category3_question_code].indicators.push({ sub_code, sub_name: _sub_name, level: !level ? 'N/A' : level})

                    return _key_indicators
                }, {})
                _category1_key_indicator = Object.values(_category1_key_indicator)

                // 핵심지표 결과 테이블
                const category1_key_indicator_header = [
                    [
                        { content: this.$t("중분류", this.report_lang) },
                        { content: this.$t("번호", this.report_lang) },
                        { content: this.$t("내용", this.report_lang) },
                        { content: this.$t("현황", this.report_lang) },
                    ]
                ]
                const category1_key_indicators = _category1_key_indicator.reduce((_key_indicator_rows, _key_indicator_ele) => {
                    const { category3_question_name, count, indicators } = _key_indicator_ele
                    indicators.forEach(({ sub_code, sub_name, level }, indicators_idx) => {
                        const _indicator_style = { ...this.tableStyles.td }
                        _indicator_style.textColor = level === null || level === 'N/A'
                            ?  _fill_color['해당없음'] //'#E0E0E0'
                            : level === 'full'
                                ? _fill_color['충족'] : level === 'half' ? _fill_color['일부항목 충족'] : _fill_color['미충족']
                        let _indicator_row = [
                            { content: sub_code, styles: this.tableStyles.td },
                            { content: sub_name, styles: this.tableStyles.td },
                            {
                                content: level === null ? 'N/A' : '●',
                                styles: _indicator_style
                            },
                        ]

                        if (indicators_idx < 1) {
                            _indicator_row.unshift({
                                content: category3_question_name, rowSpan: count, styles: this.tableStyles.td
                            })
                        }


                        _key_indicator_rows.push(_indicator_row)
                    });

                    return _key_indicator_rows
                }, [])


                autoTable(doc, {
                    theme: 'grid',
                    startY: position_y,
                    tableWidth: this.pageContentWidth,
                    showHead: 'everyPage',
                    rowPageBreak: 'auto',
                    margin: { ...this.jsPDFOpt.margin, top: this.firstElementSpacing, left: this.jsPDFOpt.margin.left },
                    styles: { ...this.tableStyles.global, halign: 'center' },
                    headStyles: this.tableStyles.th,
                    head: category1_key_indicator_header,
                    body: category1_key_indicators,
                    didDrawPage: (HookData) => {                  
                        this.addHeader(HookData.doc)
                    }
                })
            
                // position_y = doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_md
                // if (this.checkNeedNewPage(doc, position_y, 100)) {
                //     position_y = this.firstElementSpacing
                // }
            }

            if (this.checkNeedNewPage(doc, position_y, 100)) {
                position_y = this.firstElementSpacing
            }

            return position_y
        },
        async generatePARAnalticsPage (doc, position_y) {
            doc.addPage();
            this.addHeader(doc, 2);
            position_y = this.firstElementSpacing

            // 정책/조치/보고 활동 유형별 분석 섹션 타이틀
            position_y = this.addTitle(doc, position_y, 1, this.$t('정책/조치/보고 활동 유형별 분석', this.report_lang), {
                footnote: this.report_lang === "ko" ? "Policy/Action/Reporting" : `${this.$t('정책', this.report_lang)}/${this.$t('조치', this.report_lang)}/${this.$t('보고', this.report_lang)}`
            })
            
            this.setFont(doc, 'table_td', null, 'medium')
            doc.setFontSize(9)
            const par_guide_text_width = this.pageContentWidth - this.jsPDFOpt.margin.left - 10
            const par_guide_text_p = doc.splitTextToSize(this.$t("| 정책 |  윤리, 환경, 노동/인권, 안전/보건 각 영역에서 기업의 정책, 목표. 지침 등이 수립되어 있는지에 대한 평가", this.report_lang), par_guide_text_width)
            const par_guide_text_a = doc.splitTextToSize(this.$t("| 조치 |  기업에서 수행한 활동 및 조치에 대한 평가 (교육, ISO 인증, 정보보안 조치 등)", this.report_lang), par_guide_text_width)
            const par_guide_text_r = doc.splitTextToSize(this.$t("| 보고 |  수행한 활동의 결과를 관리 및 공개하고 있는지에 대한 평가 (온실가스 배출량, 고충처리 건수 등)", this.report_lang), par_guide_text_width)

            const par_guide_text_p_dim = doc.getTextDimensions(par_guide_text_p)
            const par_guide_text_a_dim = doc.getTextDimensions(par_guide_text_a)
            const par_guide_text_r_dim = doc.getTextDimensions(par_guide_text_r)

            doc.setFillColor(...this.jsPDFOpt.card.fillColor)
            doc.setLineWidth(1.5)
            doc.setDrawColor(this.jsPDFOpt.card.borderColor)
            const par_guide_box_height = 6 + par_guide_text_p_dim.h + 6 + par_guide_text_a_dim.h + 6 + par_guide_text_r_dim.h + 6
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, par_guide_box_height, 'FD')
            
            const par_guide_text_a_y = position_y + ((par_guide_box_height - par_guide_text_a_dim.h) / 2) + 6
            const par_guide_text_p_y = par_guide_text_a_y - par_guide_text_p_dim.h - 6
            const par_guide_text_r_y = par_guide_text_a_y + par_guide_text_a_dim.h + 6;

            doc.text(par_guide_text_p, this.jsPDFOpt.margin.right + 10, par_guide_text_p_y);
            doc.text(par_guide_text_a, this.jsPDFOpt.margin.right + 10, par_guide_text_a_y);
            doc.text(par_guide_text_r, this.jsPDFOpt.margin.right + 10, par_guide_text_r_y);

            position_y += par_guide_box_height + 20


            // 활동 유형별 점수 분석
            position_y = this.addTitle(doc, position_y, 2, this.$t(`활동 유형별 점수 분석`, this.report_lang), { skip_divider: true, no_margin: true, no_padding: true })
            let _par_score_analytics_part_spacing = 5

            // 활동 유형별 점수 분석 - 차트
            const _par_score_analytics_chart_area_width = (this.pageContentWidth * 0.6) - _par_score_analytics_part_spacing
            const _par_score_analytics_chart_area_height = _par_score_analytics_chart_area_width * 0.5 // * 0.65
            const _par_score_analytics_chart_area_position_x_begin = this.jsPDFOpt.margin.left
            const _par_score_analytics_chart_area_position_y_begin = position_y
            // doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.setFillColor('#fff')
            doc.setLineWidth(this.jsPDFOpt.card.lineWidth)
            doc.setDrawColor(this.jsPDFOpt.card.borderColor)
            doc.rect(_par_score_analytics_chart_area_position_x_begin, _par_score_analytics_chart_area_position_y_begin, _par_score_analytics_chart_area_width, _par_score_analytics_chart_area_height, 'FD')

            // 차트 생성
            const _static_par_chart_img = this.generatePAR_BarChartInstance()

            // // 차트 삽입
            const _par_chart_bar_width = _par_score_analytics_chart_area_width * 0.7 // 0.75
            const _par_chart_bar_height = _par_score_analytics_chart_area_width * 0.5 // 0.55
            const _par_chart_bar_positoin_x = _par_score_analytics_chart_area_position_x_begin + ((_par_score_analytics_chart_area_width - _par_chart_bar_width) / 2)
            const _par_chart_bar_positoin_y = _par_score_analytics_chart_area_position_y_begin + ((_par_score_analytics_chart_area_height - _par_chart_bar_height) / 2)
            doc.addImage(_static_par_chart_img, 'png', _par_chart_bar_positoin_x, _par_chart_bar_positoin_y, _par_chart_bar_width, _par_chart_bar_height);


            // // 활동 유형별 점수 분석 - 가이드
            const _par_score_analytics_guide_area_width = (this.pageContentWidth * 0.4) - _par_score_analytics_part_spacing
            const _par_score_analytics_guide_area_height = _par_score_analytics_chart_area_height
            const _par_score_analytics_guide_area_inner_width = _par_score_analytics_guide_area_width - (_par_score_analytics_part_spacing * 3)
            const _par_score_analytics_guide_area_x = this.jsPDFOpt.margin.left + _par_score_analytics_chart_area_width + (_par_score_analytics_part_spacing * 2)
            doc.setLineWidth(this.jsPDFOpt.card.lineWidth);
            doc.setDrawColor(this.jsPDFOpt.card.borderColor);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(_par_score_analytics_guide_area_x, position_y, _par_score_analytics_guide_area_width, _par_score_analytics_guide_area_height, 'FD')

            const _par_score_analytics_guide_text_x = _par_score_analytics_guide_area_x + (_par_score_analytics_part_spacing * 2)
            let _par_score_analytics_guide_text_y = position_y + (_par_score_analytics_guide_area_height / 2)

            this.setFont(doc, 'table_td')
            doc.setFontSize(10);

            // 가이드 머릿말
            const _par_score_analytics_guide_text_head = doc.splitTextToSize(this.$t(`활동 유형별 점수 분석 결과,`, this.report_lang), _par_score_analytics_guide_area_inner_width);
            let _par_score_analytics_guide_text_head_dim = doc.getTextDimensions(_par_score_analytics_guide_text_head)

            // 가이드 본문
            const _par_score_analytics_score = this.scoring.par_scoring_pd.total_scoring_pd
            let _par_score_analytics_guide_text_body = this.par_score_analytics_guide_text[this.report_lang] // `'정책' 유형은 ${this.roundToOneDecimalPlace(_par_score_analytics_score['P']['converted_score'])} 점, '조치' 유형은 ${this.roundToOneDecimalPlace(_par_score_analytics_score['A']['converted_score'])}점, '보고' 유형은 ${this.roundToOneDecimalPlace(_par_score_analytics_score['R']['converted_score'])} 점 입니다.`
            _par_score_analytics_guide_text_body = doc.splitTextToSize(_par_score_analytics_guide_text_body, _par_score_analytics_guide_area_inner_width);
            let _par_score_analytics_guide_text_body_dim = doc.getTextDimensions(_par_score_analytics_guide_text_body)
            
            // 가이드 끝말
            let _par_score_analytics_score_min = Object.values(_par_score_analytics_score).map(({ converted_score }) => converted_score)
            _par_score_analytics_score_min = Math.min(..._par_score_analytics_score_min)
            
            let _min_score_par_type = []
            const par_type_ko = { "P": "정책", "A": "조치", "R": "보고" }
            Object.entries(_par_score_analytics_score).forEach(([type, value]) => {
                if (value.converted_score === _par_score_analytics_score_min) {
                    _min_score_par_type.push(`'${this.$t(par_type_ko[type], this.report_lang)}'`)
                }
            })
            _min_score_par_type = _min_score_par_type.join(', ')

            let _par_score_analytics_guide_text_tail = this.report_lang === "ko"
                ? `귀사는 ${_min_score_par_type} 유형에서 적극적인 개선이 필요합니다.`
                : this.report_lang === "en"
                    ? `The company needs to actively improve in the '${_min_score_par_type}' type.`
                    : `贵公司在‘${_min_score_par_type}’类型上需要积极改进。`
            _par_score_analytics_guide_text_tail = doc.splitTextToSize(_par_score_analytics_guide_text_tail, _par_score_analytics_guide_area_inner_width);
            let _par_score_analytics_guide_text_tail_dim = doc.getTextDimensions(_par_score_analytics_guide_text_tail)

            // 가이드 텍스트 Y값 계산 및 중앙정렬 배치
            let _par_score_analytics_guide_text_body_position_y = _par_score_analytics_guide_text_y - (_par_score_analytics_guide_text_body_dim.h) / 2
            doc.text(_par_score_analytics_guide_text_body, _par_score_analytics_guide_text_x, _par_score_analytics_guide_text_body_position_y);

            let _par_score_analytics_guide_text_head_position_y = _par_score_analytics_guide_text_body_position_y - _par_score_analytics_guide_text_head_dim.h - _par_score_analytics_part_spacing
            doc.text(_par_score_analytics_guide_text_head, _par_score_analytics_guide_text_x, _par_score_analytics_guide_text_head_position_y, { lineHeightFactor: 1.3 });

            if (this.report_lang !== "ko") {
                _par_score_analytics_part_spacing += 7
            }
            let _par_score_analytics_guide_text_taii_position_y = _par_score_analytics_guide_text_body_position_y + _par_score_analytics_guide_text_tail_dim.h + _par_score_analytics_part_spacing
            doc.text(_par_score_analytics_guide_text_tail, _par_score_analytics_guide_text_x, _par_score_analytics_guide_text_taii_position_y );
        
            position_y += _par_score_analytics_chart_area_height + this.jsPDFOpt.spacing.section_sm

            if (this.checkNeedNewPage(doc, position_y, 80)) {
                position_y = this.firstElementSpacing
            }
            

            // 영역 및 활동유형별 성과 비교
            // position_y = this.addTitle(doc, position_y, 2, this.$t(`영역 및 활동유형별 성과 비교 및 주요 개선 필요사항`, this.report_lang), { skip_divider: true, no_margin: this.report_lang == "ko" })
            position_y = this.addTitle(doc, position_y, 2, this.$t(`영역 및 활동유형별 성과 비교 및 주요 개선 필요사항`, this.report_lang), { skip_divider: true, no_margin: true })

            // 요약
            const {
                P: par_category1_p,
                A: par_category1_a,
                R: par_category1_r,
            } = this.scoring.par_scoring_pd.category1_scoring_pd

            const find_par_min_score_category1 = (par_category1) => {
                return par_category1.reduce((_p_min_category1, { category1_question_name, converted_score }) => {
                    if (_p_min_category1.score === null) {
                        _p_min_category1.category1_name = category1_question_name
                        _p_min_category1.score = converted_score
                    } else if (_p_min_category1.score > converted_score) {
                        _p_min_category1.category1_name = category1_question_name
                        _p_min_category1.score = converted_score
                    }
                    return _p_min_category1
                }, { category1_name: null, score: null })
            }

            const par_category1_p_min_category1 = find_par_min_score_category1(par_category1_p)
            const par_category1_a_min_category1 = find_par_min_score_category1(par_category1_a)
            const par_category1_r_min_category1 = find_par_min_score_category1(par_category1_r)

            this.setFont(doc, 'table_td', null)
            doc.setFontSize(10.5)
            const _par_min_category1_spacing = 5
            let _par_min_category1_text = {
                "ko": `'정책' 활동에서는 '${par_category1_p_min_category1.category1_name}' 영역이, '조치' 활동에서는 '${par_category1_a_min_category1.category1_name}' 영역이, '보고' 활동에서는 '${par_category1_r_min_category1.category1_name}' 영역이 상대적으로 부족하여 개선이 필요함`,
                "en": `In the 'Policy' activity, the '${this.$t(par_category1_p_min_category1.category1_name, this.report_lang)}' area requires improvement; in the 'Action' activity, the '${this.$t(par_category1_a_min_category1.category1_name, this.report_lang)}' area also requires improvement; and in the 'Report' activity, the '${this.$t(par_category1_r_min_category1.category1_name, this.report_lang)}' area is relatively lacking and needs improvement.`,
                "ca": `在‘政策’活动中，'${this.$t(par_category1_p_min_category1.category1_name, this.report_lang)}'领域需要改进；在‘措施’活动中，'${this.$t(par_category1_a_min_category1.category1_name, this.report_lang)}'领域同样需要改进；在‘报告’活动中，'${this.$t(par_category1_r_min_category1.category1_name, this.report_lang)}'领域相对不足，需要改进。`
            }
            _par_min_category1_text = doc.splitTextToSize(_par_min_category1_text[this.report_lang], this.pageContentWidth - (_par_min_category1_spacing * 4));
            const _par_min_category1_text_dim = doc.getTextDimensions(_par_min_category1_text)

            const _par_min_category1_text_area_height = _par_min_category1_text_dim.h + (_par_min_category1_spacing * 3)
            doc.setLineWidth(this.jsPDFOpt.card.lineWidth);
            doc.setDrawColor(this.jsPDFOpt.card.borderColor);
            doc.setFillColor(...this.jsPDFOpt.card.fillColor);
            doc.rect(this.jsPDFOpt.margin.left, position_y, this.pageContentWidth, _par_min_category1_text_area_height, 'FD')

            const _par_min_category1_text_postion_y = position_y + ((_par_min_category1_text_area_height - _par_min_category1_text_dim.h) / 2) + (_par_min_category1_spacing * 1.45)
            doc.text(_par_min_category1_text, this.jsPDFOpt.margin.left + (_par_min_category1_spacing * 2), _par_min_category1_text_postion_y - 0.3, { lineHeightFactor: 1.3 })
            position_y += _par_min_category1_text_area_height + this.jsPDFOpt.spacing.section_xs

            if (this.checkNeedNewPage(doc, position_y, 100)) {
                position_y = this.firstElementSpacing
            }

            // 차트
            const _par_score_analytics_chart_spacing = 5
            const _par_category1_chart_area_width = (this.pageContentWidth * 0.4) - _par_score_analytics_chart_spacing
            const _par_category1_chart_area_height = _par_category1_chart_area_width * 0.90
            const _par_category1_table_position_left = this.jsPDFOpt.margin.left + _par_category1_chart_area_width + (_par_score_analytics_chart_spacing * 2)
            const _par_category1_table_width = (this.pageContentWidth * 0.6) - _par_score_analytics_chart_spacing

            const _par_category1_chart_width = this.report_lang === "en"
                ? _par_category1_chart_area_width * 1
                : _par_category1_chart_area_width * 0.85
            const _par_category1_chart_height = this.report_lang === "en"
                ? _par_category1_chart_width * 0.55
                :  _par_category1_chart_width * 0.65
                
            const _par_types = ['P','A','R']
            const _par_types_ko = { P: '정책', A: '조치', R: '보고' }

            // 활동영역별 개선과제
            const _par_actionplan_requirements = _par_types.reduce((_par_requirements, _par_type) => {
                if (!_par_requirements[_par_type]) _par_requirements[_par_type] = []
                _par_requirements[_par_type] = this.scoring.par_scoring_pd.actionplan_pd.filter(({ par_type }) => par_type === _par_type)
                return _par_requirements
            }, {})

            for (const [_par_index, _par_type] of _par_types.entries()) {
                if (this.checkNeedNewPage(doc, position_y, 100)) {
                    position_y = this.firstElementSpacing
                }
                
                const _par_category1_scoring = this.scoring.par_scoring_pd.category1_scoring_pd[_par_type].map((_category1) => ({
                    ..._category1, question_name: _category1.category1_question_name, 환산_점수: this.roundToOneDecimalPlace(_category1.converted_score)
                }))

                const _par_category1_scoring_label = _par_category1_scoring.map(({ question_name }) => question_name)
                const _par_category1_scoring_score = _par_category1_scoring.map(({ 환산_점수 }) => 환산_점수)

                // 차트 제목
                position_y = this.addTitle(doc, position_y, 3, `[${this.$t(_par_types_ko[_par_type], this.report_lang)}] ${this.$t('활동', this.report_lang)}`, { skip_divider: true })

                let performance_comparison_chart_position_y = this.addTitle(doc, position_y, 4, this.$t('영역별 성과 비교', this.report_lang), { skip_divider: true, fixed_y: true })
                const _par_category1_chart_area_position_y = performance_comparison_chart_position_y + 5
                const _par_category1_chart_position_x = this.jsPDFOpt.margin.left + ((_par_category1_chart_area_height - _par_category1_chart_width) / 2) + (_par_score_analytics_chart_spacing / 2)
                const _par_category1_chart_position_y = _par_category1_chart_area_position_y + ((_par_category1_chart_area_height - _par_category1_chart_height) / 2)
                
                doc.setFillColor('#fff')
                doc.setLineWidth(this.jsPDFOpt.card.lineWidth)
                doc.setDrawColor(this.jsPDFOpt.card.borderColor)
                doc.rect(this.jsPDFOpt.margin.left, _par_category1_chart_area_position_y, _par_category1_chart_area_width, _par_category1_chart_area_height, 'FD')
                
                // 차트 생성
                const _static_par_category1_chart_img = await this.generatecategory1AreaChartInstance(_par_category1_scoring, { emphasis_max: true, emphasis_min: true })
                if (this.category1AreaChartInstance) {
                    this.category1AreaChartInstance.destroy()
                    this.category1AreaChartInstance = null
                }

                doc.addImage(_static_par_category1_chart_img, 'png', _par_category1_chart_position_x + 4, _par_category1_chart_position_y, _par_category1_chart_width, _par_category1_chart_height);

                // 성과 점수표
                const performance_score_table_option = {
                    skip_divider: true,
                    no_margin: true,
                    position_x: _par_category1_table_position_left,
                }

                let _performance_score_table_footnote_text = this.$t("(각 영역별 점수는 100점 만점 기준 환산 값)", this.report_lang)
                if (this.report_lang === "ko") {
                    performance_score_table_option.footnote = _performance_score_table_footnote_text
                }
                position_y = this.addTitle(doc, position_y, 4, this.$t('영역별 점수', this.report_lang), performance_score_table_option)
                const _par_category1_scoring_body = _par_category1_scoring_label.map((_label, _label_idx) => ([
                    { content: this.splitByManagement(this.$t(_label, this.report_lang)), styles: this.tableStyles.td },
                    { content: _par_category1_scoring_score[_label_idx], styles: this.tableStyles.td }
                ]))

                autoTable(doc, {
                    theme: 'grid',
                    startY: position_y,
                    tableWidth: _par_category1_table_width,
                    showHead: 'everyPage',
                    rowPageBreak: 'auto',
                    margin: { ...this.jsPDFOpt.margin, top: this.firstElementSpacing, left: _par_category1_table_position_left },
                    styles: { ...this.tableStyles.global, halign: 'center' },
                    head: [[
                        { content: this.$t('영역', this.report_lang), styles: { ...this.tableStyles.th, cellWidth: _par_category1_table_width * 0.32 } },
                        { content: this.$t('점수', this.report_lang), styles: this.tableStyles.th }
                    ]],
                    body: _par_category1_scoring_body,
                    didDrawPage: (HookData) => {                  
                        this.addHeader(HookData.doc)
                    }
                })
                position_y = doc.lastAutoTable.finalY

                if (this.report_lang !== "ko") {
                    this.setFont(doc, 'footnote')
                    _performance_score_table_footnote_text = doc.splitTextToSize(_performance_score_table_footnote_text, _par_category1_table_width)
                    const _performance_score_table_footnote_text_dim = doc.getTextDimensions(_performance_score_table_footnote_text)
                    position_y += _performance_score_table_footnote_text_dim.h + 2
                    doc.text(_performance_score_table_footnote_text, this.jsPDFOpt.margin.left + this.pageContentWidth, position_y, { align: 'right' })
                }

                position_y += this.jsPDFOpt.spacing.section_xs - 5
                

                // 주요 개선 필요사항
                position_y = this.addTitle(doc, position_y, 4, this.$t('주요 개선 필요사항', this.report_lang), { skip_divider: true, no_padding: true, position_x: _par_category1_table_position_left })                
                const _par_actionplan_req_table_head = [
                    [
                        { content: this.$t("중분류", this.report_lang), styles: this.tableStyles.th },
                        { content: this.$t("번호", this.report_lang), styles: this.tableStyles.th },
                        { content: this.$t("내용", this.report_lang), styles: this.tableStyles.th },
                    ]
                ]
                const _par_actionplan_requirements_body = _par_actionplan_requirements[_par_type].reduce((_rows, _data) => {
                    _rows.push([
                        { content: this.splitByManagement(this.$t(_data.category1_question_name, this.report_lang)), styles: { ...this.tableStyles.td, cellWidth: _par_category1_table_width * 0.32 } },
                        { content: _data.sub_code, styles: this.tableStyles.td },
                        { content: this.report_lang === "ko" ? _data.sub_name : this.report_lang === "ca" ? _data.sub_name_ca : _data.sub_name_ea , styles: { ...this.tableStyles.td, halign: 'left' } }
                    ])
                    return _rows
                }, [])

                autoTable(doc, {
                    theme: 'grid',
                    startY: position_y,
                    tableWidth: _par_category1_table_width,
                    showHead: 'everyPage',
                    rowPageBreak: 'auto',
                    margin: { ...this.jsPDFOpt.margin, top: this.firstElementSpacing, left: _par_category1_table_position_left },
                    styles: { ...this.tableStyles.global, halign: 'center'},
                    head: _par_actionplan_req_table_head,
                    body: _par_actionplan_requirements_body,
                    didDrawPage: (HookData) => {                  
                        this.addHeader(HookData.doc)
                    }
                })

                position_y = _par_index < _par_types.length - 1 ? doc.lastAutoTable.finalY + this.jsPDFOpt.spacing.section_sm : doc.lastAutoTable.finalY
            }

            position_y += this.jsPDFOpt.spacing.section_xs
            return position_y
        },
        generateCategory1PieChartInstance (category1_score) {
            return new Promise((resolve) => {
                const _scope1_data = {
                    datasets: [{
                        data: category1_score,
                        fill: true,
                        backgroundColor: [
                            'rgba(0, 105, 176, 1)',
                            'rgba(236, 239, 241, 0.7)'
                            // 'rgba(228, 220, 211, 0.4)'
                        ],
                        borderColor: [
                            'rgba(0, 105, 176, 1)',
                            'rgba(144, 164, 174, 0.6)'
                        ],
                    }]
                }

                const _common_option = {
                    global: {
                        aspectRatio: 5/5,
                        responsive: false,
                        maintainAspectRatio: false,
                        responsiveAnimationDuration: 0,
                        animation: {
                            duration: 0,
                            onComplete: function () {
                                resolve(this.toBase64Image('image/jpg', 1));
                            }
                        }
                    },
                    plugins: {
                        datalabels: { display: false }
                    },
                }

                const _scope1_area_option = {
                    ..._common_option.global,
                    elements: { line: { borderWidth: 1 } },
                    scales: {},
                    plugins: _common_option.plugins,
                    cutout: '77.5%'
                }
    
                if (!this.category1PieChartInstance) {
                    this.category1PieChartInstance = this.$chartjs.createChart(
                        document.getElementById('category1-chart-pie'),
                        {
                            type: 'doughnut',
                            data: _scope1_data,
                            options: _scope1_area_option
                        }
                    )
                } else {
                    this.$chartjs.updateChart(this.category1PieChartInstance, _scope1_data, _scope1_area_option)
                }
            })
            
            // return this.drawCategory1PieChartImage()
        },
        drawCategory1PieChartImage () {
            return this.category1PieChartInstance.toBase64Image('image/jpg', 1)
        },
        generatePAR_Category1AreaChartInstance (category1_label, category1_score, opt = {}) {
            let _category1_label = category1_label.map(question_name => this.$t(question_name, this.report_lang))
            if (this.report_lang === 'en') {
                _category1_label = this.splitByManagement(_category1_label)
            }

            if (!opt.emphasis) {
                opt.emphasis = false
            }

            const _scope1_data = {
                labels: _category1_label,
                datasets: [{
                    label: this.headerInfo?.company_name,
                    data: category1_score,
                    fill: true,
                    backgroundColor: 'rgba(0, 105, 177, 0.4)',
                    borderColor: 'rgb(0, 105, 177)', // 'rgb(90, 162, 235)',
                    pointBackgroundColor: 'rgb(90, 162, 235)'
                }]
            }

            const _common_option = {
                global: {
                    aspectRatio: this.report_lang === 'en' ? 5/3 : 4.7/3,
                    responsive: false,
                    maintainAspectRatio: false,
                    responsiveAnimationDuration: 0,
                    animation: {
                        duration: 0,
                        // onComplete: function () {
                        //     resolve(this.toBase64Image('image/jpg', 1));
                        // }
                    }
                },
                plugins: {
                    legend: { display: false },
                    datalabels: {
                        display: false
                    }
                },
                scales: {
                    max: 100,
                    beginAtZero: true,
                    ticks: {
                        display: false
                    }
                }
            }

            const _scope1_area_option = {
                ..._common_option.global,
                layout: {
                    // padding: {
                    //     top: this.report_lang === 'en' ? 0 : 10,
                    //     right: 15,
                    //     bottom: this.report_lang === 'en' ? 0 : 10,
                    //     left: 15
                    // },
                },
                elements: { line: { borderWidth: 1.5 } },
                scales: {
                    r: {
                        ..._common_option.scales,
                        ticks: {
                            ..._common_option.scales.ticks,
                            color: '#E0E0E0',
                            stepSize: 25
                        },
                        grid: {
                            color: '#E0E0E0'
                        },
                        pointLabels: {
                            display: true,
                            padding: 10,
                            font: {
                                family: "Noto Sans KR",
                                size: (context) => {
                                    return context.label === opt.emphasis_label ? 16.5 : 14;
                                },
                                weight: (context) => {
                                    return context.label === opt.emphasis_label ? 'bold' : 'normal';
                                },
                            },
                            color: (context) => {
                                return context.label === opt.emphasis_label ? 'rgb(0, 105, 177)' : '#616161';
                            }
                        }
                        // pointLabels: {
                        //     display: true,
                        //     padding: 10,
                        //     font: {
                        //         family: "Noto Sans KR",
                        //         size: 11, // 13,
                        //         weight: 'normal',
                        //     },
                        //     color: "rgb(71, 71, 71)"
                        // }
                    }
                },
                plugins: _common_option.plugins
            }

            if (!this.PAR_Category1AreAChartInstance) {
                this.PAR_Category1AreAChartInstance = this.$chartjs.createChart(
                    document.getElementById('par-category1-chart-area'),
                    {
                        type: 'radar',
                        data: _scope1_data,
                        options: _scope1_area_option
                    }
                )
            } else {
                this.$chartjs.updateChart(this.PAR_Category1AreAChartInstance, _scope1_data, _scope1_area_option)
            }
            
            // if (this.PAR_Category1AreAChartInstance) {
            //     this.PAR_Category1AreAChartInstance.destroy()
            //     this.PAR_Category1AreAChartInstance = null
            // }
            
            return this.drawPAR_Category1AreaChartImage()
        },
        drawPAR_Category1AreaChartImage () {
            return this.PAR_Category1AreAChartInstance.toBase64Image('image/jpg', 1)
        },
        generatePAR_BarChartInstance () {
            const _par_score_set = this.scoring.par_scoring_pd.total_scoring_pd
            const _category1_data = [
                this.roundToOneDecimalPlace(_par_score_set['P']['converted_score']),
                this.roundToOneDecimalPlace(_par_score_set['A']['converted_score']),
                this.roundToOneDecimalPlace(_par_score_set['R']['converted_score'])
            ]
            const _scope1_data = {
                labels: [
                    this.$t("정책", this.report_lang),
                    this.$t("조치", this.report_lang),
                    this.$t("보고", this.report_lang),
                ],
                datasets: [{
                    label: this.headerInfo?.company_name,
                    data: _category1_data,
                    fill: true,
                    backgroundColor: 'rgba(0, 105, 177, 1)',
                    borderColor: 'rgba(0, 105, 177, 1)',
                    pointBackgroundColor: 'rgb(90, 162, 235)',
                    barPercentage: 1,
                    categoryPercentage: 0.3
                }]
            }

            const _common_option = {
                global: {
                    // aspectRatio: this.report_lang === 'en' ? 5/3 : 4.7/3,
                    aspectRatio: 4.7/3,
                    responsive: false,
                    maintainAspectRatio: false,
                    responsiveAnimationDuration: 0,
                    animation: { duration: 0 }
                },
                plugins: {
                    legend: { display: false },
                    datalabels: { display: false }
                },
                scales: {
                    max: 100,
                    beginAtZero: true,
                    ticks: {
                        display: false
                    }
                }
            }

            const _scope1_bar_option = {
                ..._common_option.global,
                layout: {
                    padding: {
                        top: Math.max.apply(null, _category1_data) < 80 ? 10 : 34,
                        // top: this.report_lang === "en" ? 5 : Math.max.apply(null, _category1_data) < 80 ? 10 : 34,
                        right: 10,
                        bottom: Math.max.apply(null, _category1_data) < 80 ? 10 : 15,
                        // bottom: this.report_lang === "en" ? 5 : Math.max.apply(null, _category1_data) < 80 ? 10 : 15,
                        left: 10,
                    },
                },
                elements: { bar: { borderWidth: 1 } },
                scales: {
                    x: {
                        max: 100,
                        grid: {
                            display: false,
                        },
                        ticks: {
                            stepSize: 25,
                            font: {
                                family: "Noto Sans KR",
                                size: 13,
                                weight: 'normal',
                            },
                            color: "rgb(71, 71, 71)"
                        }
                    },
                    y: {
                        ..._common_option.scales,
                        max: 100 ,
                        ticks: {
                            display: false,
                            font: {
                                family: "Noto Sans KR",
                                padding: 0,
                                size: 10,
                                weight: 'normal',
                            },
                            color: "rgb(71, 71, 71)",
                            padding: 0,
                            autoSkip: false
                        },
                        grid: {
                            borderWidth: 0,
                            display: false,
                            drawOnChartArea: false
                        }
                    }
                },
                plugins: {
                    ..._common_option.plugins,
                    datalabels: {
                        display: true,
                        align: 'end',
                        anchor: 'end',
                        color: '#343a40',
                        font: {
                            size: 12
                        }
                    }
                }
            }
            
            if (this.PAR_BarChartInstance) {
                this.PAR_BarChartInstance.destroy()
                this.PAR_BarChartInstance = null
            }

            this.PAR_BarChartInstance = this.$chartjs.createChart(
                document.getElementById('par-chart-bar'),
                {
                    type: 'bar',
                    data: _scope1_data,
                    options: _scope1_bar_option
                }
            )
            
            return this.drawChartPARCategory1Image()
        },
        drawChartPARCategory1Image () {
            let _PAR_Category1BarChart_url = null
            if (this.PAR_BarChartInstance) {
                _PAR_Category1BarChart_url = this.PAR_BarChartInstance.toBase64Image('image/png', 0.9)
            }

            return _PAR_Category1BarChart_url
        },
        generateKeyFigurePage (doc, position_y) {
            position_y = this.firstElementSpacing
            doc.addPage();
            this.addHeader(doc);

            // 데이터테이블 전역 footnote
            let _datatable_footnote = this.$t('위 데이터는 기업이 작성한 값으로, 값에 대한 증빙을 확인할 수 있는 경우 평가에 반영되었습니다.', this.report_lang)
            _datatable_footnote = doc.splitTextToSize(_datatable_footnote, this.pageContentWidth)
            const _datatable_footnote_dim = doc.getTextDimensions(_datatable_footnote);
            const _datatable_footnote_position_x = this.jsPDFOpt.margin.left + this.pageContentWidth
            const _datatable_footnote_spacing_top = (doc) => {
                return doc.lastAutoTable.finalY + 10
            }
            const _datatable_footnote_spacing_bottom = _datatable_footnote_dim.h + this.jsPDFOpt.spacing.section_xs // this.jsPDFOpt.spacing.section_sm

            // Key Figures 섹션 타이틀
            position_y = this.addTitle(doc, position_y, 1, 'Key Figures')


            // 온실가스 배출량
            position_y = this.addTitle(doc, position_y, 3, this.$t(`온실가스 배출량`, this.report_lang), { skip_divider: true, no_padding: true })
            const _column_division_width = 80
            const _column_unit_width = 30

            let _greengas_unit = !this.keyFigureInfo_greengas["3년간 온실가스 간접 배출량(Scope 1)"] && !this.keyFigureInfo_greengas["3년간 온실가스 간접 배출량(Scope 1)"]
                ? 'tCO2e'
                : this.keyFigureInfo_greengas["3년간 온실가스 간접 배출량(Scope 1)"].unit || this.keyFigureInfo_greengas["3년간 온실가스 간접 배출량(Scope 2)"].unit

            const _greengas_data = {
                Scope1: !this.keyFigureInfo_greengas["3년간 온실가스 직접 배출량(Scope 1)"]
                    ? { "FY2021": null, "FY2022": null, "FY2023": null }
                    : this.keyFigureInfo_greengas["3년간 온실가스 직접 배출량(Scope 1)"].value,
                Scope2: !this.keyFigureInfo_greengas["3년간 온실가스 간접 배출량(Scope 2)"]
                    ? { "FY2021": null, "FY2022": null, "FY2023": null }
                    : this.keyFigureInfo_greengas["3년간 온실가스 간접 배출량(Scope 2)"].value
            }

            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: { ...this.jsPDFOpt.margin, top: 0, left: this.jsPDFOpt.margin.left },
                styles: this.datatables.global,
                body: [
                    [
                        { content: this.$t('구분', this.report_lang), styles: this.datatables.th },
                        { content: this.$t('단위', this.report_lang), styles: { ...this.datatables.th, cellWidth: _column_unit_width } },
                        { content: this.$t('FY2021', this.report_lang), styles: this.datatables.th },
                        { content: this.$t('FY2022', this.report_lang), styles: this.datatables.th },
                        { content: this.$t('FY2023', this.report_lang), styles: this.datatables.th }
                    ],
                    [
                        { content: 'Scope 1', styles: { ...this.datatables.th, cellWidth: _column_division_width / 2 } },
                        { content: _greengas_unit, rowSpan: 2, styles: { ...this.datatables.th, cellWidth: _column_division_width / 2,  } },
                        { content: this.formatNumber(_greengas_data['Scope1']['FY2021']) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(_greengas_data['Scope1']['FY2022']) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(_greengas_data['Scope1']['FY2023']) || ' - ', styles: this.datatables.td },
                    ],
                    [
                        { content: 'Scope 2', rowSpan: 1, styles: { ...this.datatables.th } },
                        { content: this.formatNumber(_greengas_data['Scope2']['FY2021']) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(_greengas_data['Scope2']['FY2022']) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(_greengas_data['Scope2']['FY2023']) || ' - ', styles: this.datatables.td },
                    ],
                ],
                didDrawCell: (data) => this.jspdf_common_draw_cell(data)
            })

            position_y = _datatable_footnote_spacing_top(doc)
            this.setFont(doc, 'footnote')
            doc.text(_datatable_footnote, _datatable_footnote_position_x, position_y, { align: 'right' });
            position_y += _datatable_footnote_spacing_bottom
            

            // 근로손실 재해율
            if (this.report_lang === "en") {
                position_y -= _datatable_footnote_dim.h / 2
            }
            position_y = this.addTitle(doc, position_y, 3, this.$t(`근로손실 재해율`, this.report_lang), { skip_divider: true, no_padding: true })
            const ltifr_data = !this.keyFigureInfo_LTIFR["근로손실재해율(LTIFR)"]
                ? {"2021": ' - ',"2022": ' - ',"2023": ' - '}
                : this.keyFigureInfo_LTIFR["근로손실재해율(LTIFR)"]

            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: { ...this.jsPDFOpt.margin, top: 0, left: this.jsPDFOpt.margin.left },
                styles: this.datatables.global,
                body: [
                    [
                        { content: this.$t('구분', this.report_lang), styles: { ...this.datatables.th, cellWidth: _column_division_width} },
                        { content: 'FY2021', styles: this.datatables.th },
                        { content: 'FY2022', styles: this.datatables.th },
                        { content: 'FY2023', styles: this.datatables.th },
                    ],
                    [
                        { content: "LTIFR", styles: this.datatables.th },
                        { content: this.formatNumber(ltifr_data['2021']) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(ltifr_data['2022']) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(ltifr_data['2023']) || ' - ', styles: this.datatables.td },
                    ]
                ],
                didDrawCell: (data) => this.jspdf_common_draw_cell(data)
            })
            position_y = _datatable_footnote_spacing_top(doc)
            this.setFont(doc, 'footnote')
            doc.text(_datatable_footnote, _datatable_footnote_position_x, position_y, { align: 'right' });
            position_y += _datatable_footnote_spacing_bottom

            if (this.checkNeedNewPage(doc, position_y)) {
                position_y = this.firstElementSpacing
            }

            // 주요인증 및 이니셔티브
            if (this.report_lang === "en") {
                position_y -= _datatable_footnote_dim.h / 2
            }
            this.setFont(doc, 'title_sm')
            position_y = this.addTitle(doc, position_y, 3, this.$t(`주요인증/이니셔티브`, this.report_lang), { skip_divider: true, no_padding: true })
            const _initiative_table_content_column_width = (this.pageContentWidth - ((_column_division_width * 2) + (_column_unit_width * 2))) / 2
            const _initiative_table_styles = {
                label: {
                    ...this.datatables.th,
                    cellWidth: _column_division_width,
                    // valign: 'middle'
                },
                indicator: {
                    ...this.datatables.td,
                    fontSize: 18,
                    cellWidth: _column_unit_width,
                    // valign: 'middle'
                },
                value: {
                    ...this.datatables.td,
                    fontSize: 9,
                    cellWidth: _initiative_table_content_column_width,
                    // valign: 'middle'
                }
            }

            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: { ...this.jsPDFOpt.margin, top: 0 },
                styles: this.datatables.global,
                body: [
                    [
                        {
                            content: this.$t('환경/에너지 인증', this.report_lang),
                            styles: _initiative_table_styles.label
                        },
                        {
                            content: '•',
                            styles: {
                                ..._initiative_table_styles.indicator,
                                textColor: this.keyFigureInfo_certification['환경/에너지경영시스템']?.status ? '#2281df' : '#d6d8db'
                            }
                        },
                        {
                            content: this.keyFigureInfo_certification['환경/에너지경영시스템']?.value,
                            styles: _initiative_table_styles.value
                        },
                        {
                            content: this.$t('윤리경영 인증', this.report_lang),
                            styles: _initiative_table_styles.label
                        },
                        {
                            content: '•',
                            styles: {
                                ..._initiative_table_styles.indicator,
                                textColor: this.keyFigureInfo_certification['윤리경영인증']?.status ? '#2281df' : '#d6d8db'
                            }
                        },
                        {
                            content: this.keyFigureInfo_certification['윤리경영인증']?.value,
                            styles: _initiative_table_styles.value
                        }
                    ],
                    [
                        {
                            content: 'CDP',
                            styles: _initiative_table_styles.label
                        },
                        {
                            content: '•',
                            styles: {
                                ..._initiative_table_styles.indicator,
                                textColor: this.keyFigureInfo_certification['CDP']?.status ? '#2281df' : '#d6d8db'
                            }
                        },
                        {
                            content: this.keyFigureInfo_certification['CDP']?.value,
                            styles: _initiative_table_styles.value
                        },
                        {
                            content: this.$t('정보보안 인증', this.report_lang),
                            styles: _initiative_table_styles.label
                        },
                        {
                            content: '•',
                            styles: {
                                ..._initiative_table_styles.indicator,
                                textColor: this.keyFigureInfo_certification['정보보안인증']?.status ? '#2281df' : '#d6d8db'
                            }
                        },
                        {
                            content: this.keyFigureInfo_certification['정보보안인증']?.value,
                            styles: _initiative_table_styles.value
                        }
                    ],
                    [
                        {
                            content: 'SBTi',
                            styles: _initiative_table_styles.label
                        },
                        {
                            content: '•',
                            styles: {
                                ..._initiative_table_styles.indicator,
                                textColor: this.keyFigureInfo_certification['SBTi']?.status ? '#2281df' : '#d6d8db'
                            }
                        },
                        {
                            content: this.keyFigureInfo_certification['SBTi']?.value,
                            styles: _initiative_table_styles.value
                        },
                        {
                            content: this.$t('안전보건 인증', this.report_lang),
                            styles: _initiative_table_styles.label
                        },
                        {
                            content: '•',
                            styles: {
                                ..._initiative_table_styles.indicator,
                                textColor: this.keyFigureInfo_certification['안전보건인증']?.status ? '#2281df' : '#d6d8db'
                            }
                        },
                        {
                            content: this.keyFigureInfo_certification['안전보건인증']?.value,
                            styles: _initiative_table_styles.value
                        }
                    ]
                ],
                didDrawCell: (data) => this.jspdf_common_draw_cell(data)
            })

            position_y = _datatable_footnote_spacing_top(doc)
            this.setFont(doc, 'footnote')
            doc.text(_datatable_footnote, _datatable_footnote_position_x, position_y, { align: 'right' });
            position_y += _datatable_footnote_spacing_bottom

            if (this.checkNeedNewPage(doc, position_y)) {
                position_y = this.firstElementSpacing
            }

            // 환경 데이터
            if (this.report_lang === "en") {
                position_y -= _datatable_footnote_dim.h / 2
            }
            position_y = this.addTitle(doc, position_y, 3, this.$t(`환경 데이터`, this.report_lang), { skip_divider: true, no_padding: true })
            autoTable(doc, {
                theme: 'grid',
                startY: position_y,
                margin: { ...this.jsPDFOpt.margin, top: 0, left: this.jsPDFOpt.margin.left },
                styles: this.datatables.global,
                body: [
                    [
                        { content: this.$t('구분', this.report_lang), styles: { ...this.datatables.th, cellWidth: _column_division_width } },
                        { content: this.$t('단위', this.report_lang), styles: { ...this.datatables.th, cellWidth: 30, halign: 'center' } },
                        { content: 'FY2021', styles: this.datatables.th },
                        { content: 'FY2022', styles: this.datatables.th },
                        { content: 'FY2023', styles: this.datatables.th }
                    ],
                    [
                        { content: this.$t('에너지 사용량', this.report_lang), styles: this.datatables.th },
                        { content: this.keyFigureInfo_environment["에너지 사용량"]?.unit || 'MWh', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["에너지 사용량"]?.value["FY2021"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["에너지 사용량"]?.value["FY2022"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["에너지 사용량"]?.value["FY2023"]) || ' - ', styles: this.datatables.td },
                    ],
                    [
                        { content: this.$t('일반 폐기물 배출량', this.report_lang), styles: this.datatables.th },
                        { content: this.keyFigureInfo_environment["일반 폐기물 배출량"]?.unit || 'ton', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["일반 폐기물 배출량"]?.value["FY2021"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["일반 폐기물 배출량"]?.value["FY2022"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["일반 폐기물 배출량"]?.value["FY2023"]) || ' - ', styles: this.datatables.td },
                    ],
                    [
                        { content: this.$t('유해 폐기물 배출량', this.report_lang), styles: this.datatables.th },
                        { content: this.keyFigureInfo_environment["유해 폐기물 배출량"]?.unit || 'ton', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["유해 폐기물 배출량"]?.value["FY2021"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["유해 폐기물 배출량"]?.value["FY2022"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["유해 폐기물 배출량"]?.value["FY2023"]) || ' - ', styles: this.datatables.td },
                    ],
                    [
                        { content: this.$t('용수 취수량', this.report_lang), styles: this.datatables.th },
                        { content: this.keyFigureInfo_environment["용수 취수량"]?.unit || 'ton', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["용수 취수량"]?.value["FY2021"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["용수 취수량"]?.value["FY2022"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["용수 취수량"]?.value["FY2023"]) || ' - ', styles: this.datatables.td },
                    ],
                    [
                        { content: 'NOx', styles: this.datatables.th },
                        { content: this.keyFigureInfo_environment["NOx(질소산화물) 배출량"]?.unit || 'ton', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["NOx(질소산화물) 배출량"]?.value["FY2021"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["NOx(질소산화물) 배출량"]?.value["FY2022"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["NOx(질소산화물) 배출량"]?.value["FY2023"]) || ' - ', styles: this.datatables.td },
                    ],
                    [
                        { content: 'SOx', styles: this.datatables.th },
                        { content: this.keyFigureInfo_environment["SOx(황산화물) 배출량"]?.unit || 'ton', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["SOx(황산화물) 배출량"]?.value["FY2021"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["SOx(황산화물) 배출량"]?.value["FY2022"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["SOx(황산화물) 배출량"]?.value["FY2023"]) || ' - ', styles: this.datatables.td },
                    ],
                    [
                        { content: this.$t('먼지', this.report_lang), styles: this.datatables.th },
                        { content: this.keyFigureInfo_environment["먼지(PM) 배출량"]?.unit || 'ton', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["먼지(PM) 배출량"]?.value["FY2021"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["먼지(PM) 배출량"]?.value["FY2022"]) || ' - ', styles: this.datatables.td },
                        { content: this.formatNumber(this.keyFigureInfo_environment["먼지(PM) 배출량"]?.value["FY2023"]) || ' - ', styles: this.datatables.td },
                    ]
                ],
                didDrawCell: (data) => this.jspdf_common_draw_cell(data)
            })

            position_y = _datatable_footnote_spacing_top(doc)
            this.setFont(doc, 'footnote')
            doc.text(_datatable_footnote, _datatable_footnote_position_x, position_y, { align: 'right' });
            position_y += _datatable_footnote_spacing_bottom

            return position_y
        },
        generateFactors () {
            if (!this.reportData?.scoring?.scoring_pd || !this.reportData.scoring.scoring_pd.length){
                this.factors = []
            } else {
                const _scoring_pd = [ ...this.reportData.scoring.scoring_pd ].sort((a, b) => {
                    // First, compare the question field
                    const subCodeComparison = a.sub_code.localeCompare(b.sub_code, undefined, { numeric: true });
                    if (subCodeComparison !== 0) {
                        return subCodeComparison;
                    }

                    return a.satisfied && !b.satisfied
                        ? -1
                        : !a.satisfied && b.satisfied
                            ? 1
                            : 0
                });

                const _lang = this.report_lang
                let _factors_raw = _scoring_pd.reduce((_factors_v2, _factor) => {
                    if (!_factor.not_applicable && _factor.sub_code) {
                        if (_factor.sub_code ==='Q4.21' && _factor.ev_name !== '지난 1년간 환경 정보 공개요청에 따라 관련 정보를 투명하게 공개함'){
                            return _factors_v2
                        }

                        let {
                            category1_question_code, category1_question_name, category1_question_name_ea, category1_question_name_ca,
                            category3_question_code, category3_question_name, category3_question_name_ea ,category3_question_name_ca,
                            sub_code, sub_name, sub_name_ca, sub_name_ea, satisfied,
                            ev_name, ev_name_e, ev_name_c, ev_reverse_name, ev_reverse_name_e, ev_reverse_name_c, ev_importance,
                            // audit_comment, audit_comment_ca, audit_comment_ea, review_comment, review_comment_ca, review_comment_ea
                        } = _factor

                        if (sub_code === "Q4.12") {
                            sub_name = "최근 3년간 온실가스 간접 배출량(Scope 2) 관리 및 공개 여부"
                            sub_name_ca = "过去3年间接温室气体排放（范围2）的管理和公开情况"
                            sub_name_ea = "Management and disclosure of indirect greenhouse gas emissions (Scope 2) over the last 3 years"
                        }

                        if (sub_code === "Q1.10" && sub_name === "책임있는 원자재 조달" && ev_name === "책임있는 원부자재 조달 정책 내 텡스텐 관련 규정을 보유함") {
                            ev_name = "책임있는 원부자재 조달 정책 내 텅스텐 관련 규정을 보유함"
                        }

                        let _category1_idx = _factors_v2.findIndex(_factors => _factors.category1_question_code === category1_question_code)
                        const _category1_question_name = _lang === "ko" ? category1_question_name : _lang === "en" ? category1_question_name_ea : category1_question_name_ca
                        if (_category1_idx < 0) {
                            _factors_v2.push({
                                category1_question_code, category1_question_name: _category1_question_name, category3: []
                            })

                            _category1_idx = _factors_v2.findIndex(_factors => _factors.category1_question_code === category1_question_code)
                        }

                        let _category3_idex = _factors_v2[_category1_idx].category3.findIndex(_factors_category3 => _factors_category3.category3_question_code === category3_question_code)
                        if (_category3_idex < 0) {
                            const _category3_question_name = _lang === "ko" ? category3_question_name : _lang === "en" ? category3_question_name_ea : category3_question_name_ca
                            _factors_v2[_category1_idx].category3.push({
                                category3_question_code, category3_question_name: _category3_question_name,
                                subs: []
                            })

                            _category3_idex = _factors_v2[_category1_idx].category3.findIndex(_factors_category3 => _factors_category3.category3_question_code === category3_question_code)
                        }

                        let [
                            _content_ev, , _sub_name,
                            // _content_audit_comment, _content_review_comment
                        ] = new Array(4).fill(null)
                        if (satisfied) {
                            _content_ev = _lang === "ko" ? ev_name : _lang === "en" ? ev_name_e : ev_name_c
                        } else {
                            _content_ev = _lang === "ko" ? ev_reverse_name : _lang === "en" ? ev_reverse_name_e : ev_reverse_name_c
                        }
                        // _content_audit_comment = _lang === "ko" ? audit_comment : _lang === "en" ? audit_comment_ea : audit_comment_ca
                        // _content_review_comment = _lang === "ko" ? review_comment : _lang === "en" ? review_comment_ea : review_comment_ca

                        if (!_content_ev) _content_ev = null
                        // if (!_content_audit_comment) _content_audit_comment = null
                        // if (!_content_review_comment) _content_review_comment = null

                        _sub_name = _lang === "ko" ? sub_name : _lang === "en" ? sub_name_ea : sub_name_ca
                        if (!_sub_name) _sub_name = null
                        // if (_content_review_comment && /^[^\p{L}\p{N}]+$/u.test(_content_review_comment) === false) {
                        //     if (this.auditor_shortname_prefix_regexp.test(_content_review_comment)) {
                        //         _content_review_comment = _content_review_comment.replace(this.auditor_shortname_prefix_regexp, '').trim()
                        //     }
                        // }
                        // _content_review_comment = this.isFieldEmpty(_content_review_comment) ? null : _content_review_comment

                        let _sub_index = _factors_v2[_category1_idx].category3[_category3_idex].subs.findIndex(({ sub_code: _sub_code }) => _sub_code === sub_code)
                        if (_sub_index === -1) {
                            _factors_v2[_category1_idx].category3[_category3_idex].subs.push({
                                sub_code,
                                sub_name: _sub_name,
                                evaluations: [],
                                sub_review_comment: null // _content_review_comment
                            })

                            _sub_index = _factors_v2[_category1_idx].category3[_category3_idex].subs.findIndex(({ sub_code: _sub_code }) => _sub_code === sub_code)
                        }
                        
                        // if (_content_audit_comment && /^[^\p{L}\p{N}]+$/u.test(_content_audit_comment) === false) {
                        //     if (this.auditor_shortname_prefix_regexp.test(_content_audit_comment)) {
                        //         _content_audit_comment = _content_audit_comment.replace(this.auditor_shortname_prefix_regexp, '').trim()
                        //     }
                        // }
                        // _content_audit_comment = this.isFieldEmpty(_content_audit_comment) ? null : _content_audit_comment
                        
                        if (_content_ev && /^[^\p{L}\p{N}]+$/u.test(_content_ev) === false) {
                            let _evaluation_content = []
                            const _row_1st = [{
                                content: satisfied ? this.$t('충족', this.report_lang) : this.$t('미충족', this.report_lang),
                                contentType: 'satisfied',
                                // rowSpan: !_content_audit_comment ? 1 : 2,
                                rowSpan: 1,
                                status: satisfied,
                                styles: {}
                            }]
                            if (ev_importance === "HIGH") {
                                _row_1st.push({
                                    content: this.$t('중요사항', this.report_lang),
                                    contentType: "importance",
                                    styles: { halign: "center", valign: "middle", fillColor: 248 }
                                })
                            }
                            _row_1st.push({ content: _content_ev, contentType: "content", styles: this.factorstables.td })
                            _evaluation_content.push(_row_1st)

                            // if (_content_audit_comment) {
                            //     _evaluation_content.push([
                            //         { content: this.$t('항목별 평가자 의견', this.report_lang), styles: { halign: "center", valign: "middle", fillColor: 248, fontSize: this.report_lang === "en" ? this.factorstables.td.fontSize - 0.3 : this.factorstables.td.fontSize } },
                            //         { content: _content_audit_comment, contentType: "assessment" }
                            //     ])
                            // }

                            _factors_v2[_category1_idx].category3[_category3_idex].subs[_sub_index].evaluations.push(..._evaluation_content)
                        }
                    }

                    return _factors_v2
                }, [])

                for (let _factor_cat1 of _factors_raw) {
                    for (let _factor_cat3 of _factor_cat1.category3) {
                        for (let _factor_subs of _factor_cat3.subs) {
                            const _flatten_sub_evaluations = [ ..._factor_subs.evaluations ].reduce((_flatten, _sub_ev) => {
                                _flatten.push( ..._sub_ev )
                                return _flatten
                            }, [])

                            const _has_importance_evaluation_or_assessment = _flatten_sub_evaluations.some(({ contentType }) => ["importance", "assessment"].includes(contentType))
                            if (_has_importance_evaluation_or_assessment) {
                                for (let _subs_evs of _factor_subs.evaluations) {
                                    let _ev_importance_or_assessment_idx = _subs_evs.findIndex(({ contentType }) => contentType && ["importance", "assessment"].includes(contentType))
                                    if (_ev_importance_or_assessment_idx == -1) {
                                        const _subs_evs_idx = _subs_evs.findIndex(({ contentType }) => contentType === "content")
                                        if (_subs_evs_idx !== -1) {
                                            _subs_evs[_subs_evs_idx].colSpan = 2
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                
                this.factors = _factors_raw
            }
        },
        createFactorsPage (doc, position_y) {
            let _is_new_page = this.checkNeedNewPage(doc, position_y, this.pageContentHeight/2) // 35
            if (_is_new_page) {
                position_y = this.firstElementSpacing
            }

            position_y = this.addTitle(doc, position_y, 1, this.$t(`세부 평가결과`, this.report_lang))

            this.factors.forEach((_cat1, _cat1_idx) => {
                if (_cat1_idx > 0 && _cat1_idx < this.factors.length) {
                    position_y += this.jsPDFOpt.spacing.section_sm
                }

                let _is_new_page = this.checkNeedNewPage(doc, position_y, 40) // 35
                if (_is_new_page) {
                    position_y = this.firstElementSpacing
                }

                position_y = this.addTitle(doc, position_y, 2, `${_cat1_idx + 1}. ${this.$t(_cat1.category1_question_name, this.report_lang)}`, { skip_divider: true, no_padding: true })

                _cat1.category3.forEach((_cat3) => {
                    // 문항별 Factors 테이블
                    _cat3.subs.forEach((_sub) => {
                        let _is_new_page = this.checkNeedNewPage(doc, position_y, 60) // 80 // 50 // 35
                        if (_is_new_page) {
                            position_y = this.firstElementSpacing
                        }

                        position_y = this.addTitle(doc, position_y, 4, `[${_cat3.category3_question_name} - ${_sub.sub_code}]  ${_sub.sub_name}`, { skip_divider: true, no_margin: true, no_padding: true })
                        position_y -= 3
                        const _flatten_sub_evaluations = [ ..._sub.evaluations ].reduce((_flatten, _sub_ev) => {
                            _flatten.push( ..._sub_ev )
                            return _flatten
                        }, [])

                        const _has_importance_evaluation_or_assessment = !!_flatten_sub_evaluations.find(({ contentType }) => ["importance", "assessment"].includes(contentType))
                        const _columnStyles = {
                            0: {
                                cellWidth: this.report_lang === "ko" ? this.pageContentWidth * 0.1 : this.pageContentWidth * 0.15,
                                halign: 'center',
                            }
                        }

                        if (_has_importance_evaluation_or_assessment) {
                            _columnStyles[1] = {
                                ...this.tableStyles.td,
                                cellWidth: this.report_lang !== "ko"
                                    ? this.pageContentWidth * 0.17
                                    : this.pageContentWidth * 0.12,
                                valign: 'middle',
                                halign: 'left',
                                cellPadding: { top: 5, right: 5, bottom: 5, left: 5 }
                            }
                        }

                        autoTable(doc, {
                            theme: 'grid',
                            startY: position_y, // - 3,
                            useCss: true,
                            margin: { ...this.jsPDFOpt.margin, top: this.firstElementSpacing - 5 },
                            body: _sub.evaluations,
                            rowPageBreak: 'auto',
                            head: [[
                                { content: this.$t('충족 여부', this.report_lang), dataKey: 'FactorState' },
                                { content: this.$t('주요 사항', this.report_lang), dataKey: 'FactorContent', colSpan: (_has_importance_evaluation_or_assessment) ? 2 : 1 }
                            ]],
                            styles: this.factorstables.global,
                            headStyles: this.factorstables.th,
                            bodyStyles: this.factorstables.td,
                            columnStyles: _columnStyles,
                            willDrawCell: (data) => {
                                if (data.section === 'body') {
                                    const { cell } = data
                                    if (data.column.dataKey === 0) {
                                        cell.text = []
                                    } else if (data.column.dataKey === 1) {
                                        if (cell.raw.contentType === "importance" && cell.raw.content) {
                                            cell.text = []
                                        }
                                    }
                                }
                            },
                            didDrawCell: (data) => {
                                if (data.section === 'body') {
                                    const { column, cell, doc } = data;
                                    if (column.dataKey === 0) {
                                        const textColor = '#ffffff'
                                        const _text = cell.raw.content
                                        const bgColor = cell.raw.status ? '#2196f3' : '#ff5722';
                                        if (this.report_lang === 'ca') {
                                            cell.styles.font = this.jsPDFOpt.fontFamily_ca
                                        } else {
                                            cell.styles.font = this.jsPDFOpt.fontFamily
                                        }

                                        // Set text color
                                        doc.setTextColor(textColor);
                                        doc.setFontSize(cell.styles.fontSize - 1.2)
                                        doc.setFillColor(bgColor);

                                        const [textWidth, textHeight] = [doc.getTextDimensions(_text).w, doc.getTextDimensions(_text).h]
                                        let [badgeWidth, badgeHeight] = [textWidth + 10, textHeight + 4.5]
                                        if (badgeWidth >= cell.width) {
                                            badgeWidth += textWidth + 3
                                        }

                                        // if (this.pageContentHeight > cell.y + badgeHeight) {
                                        if (this.pageContentHeight >= cell.y + 1) {
                                            doc.roundedRect(cell.x + ((cell.width - badgeWidth) / 2), cell.y + ((cell.height - badgeHeight) / 2), badgeWidth, badgeHeight, 3, 3, 'F')
                                            
                                            // Draw text in the center of the cell
                                            doc.text(_text, cell.x + cell.width / 2, cell.y + (cell.height / 2) + 0.15, {
                                                baseline: 'middle',
                                                align: 'center'
                                            });
                                        }
                                    } else if (column.dataKey === 1) {
                                        if (cell.raw.contentType === "importance" && cell.raw.content) {
                                            // Set text color
                                            doc.setTextColor('#ffffff');
                                            doc.setFontSize(this.report_lang === 'ko' ? cell.styles.fontSize - 1.5 : cell.styles.fontSize - 2)
                                            doc.setFillColor('#ff5722');

                                            const _text = cell.raw.content
                                            const [textWidth, textHeight] = [doc.getTextDimensions(_text).w, doc.getTextDimensions(_text).h]
                                            let [badgeWidth, badgeHeight] = [textWidth + 10, textHeight + 4.5]
                                            if (badgeWidth >= cell.width) {
                                                badgeWidth += textWidth + 3
                                            }

                                            doc.roundedRect(cell.x + ((cell.width - badgeWidth) / 2), cell.y + ((cell.height - badgeHeight) / 2), badgeWidth, badgeHeight, 3, 3, 'F')
                                        
                                            // Draw text in the center of the cell
                                            doc.text(_text, cell.x + cell.width / 2, cell.y + (cell.height / 2) + 0.15, {
                                                baseline: 'middle',
                                                align: 'center'
                                            });

                                        } else if (cell.raw.contentType === "content" && cell.raw.content) {
                                            if (this.report_lang === 'ca') {
                                                cell.styles.font = this.jsPDFOpt.fontFamily_ca
                                            } else {
                                                cell.styles.font = this.jsPDFOpt.fontFamily
                                            }
                                        } 
                                    }
                                }
                            },
                            didDrawPage: (HookData) => {                  
                                this.addHeader(HookData.doc)
                            }
                        })

                        this.setFont(doc, null)
                        position_y = doc.lastAutoTable.finalY

                        // // 문항별 실사의견 테이블
                        // if (_sub.sub_review_comment && /^[\s\W]*$/.test(_sub.sub_review_comment) === false) {
                        //     autoTable(doc, {
                        //         theme: 'grid',
                        //         startY: position_y,
                        //         useCss: true,
                        //         margin: { ...this.jsPDFOpt.margin, top: this.firstElementSpacing - 5 },
                        //         styles: { valign: 'middle' },
                        //         body: [
                        //             [
                        //                 {
                        //                     content: this.$t('평가자 종합 의견', this.report_lang),
                        //                     styles: {
                        //                         ...this.tableStyles.th,
                        //                         fontSize: this.report_lang === "ca" ? 7.8 : 8.5,
                        //                         cellWidth: this.report_lang === "ko" ? 38.7 : 58,
                        //                         halign: 'center',
                        //                         cellPadding: { top: 4, right: 5, bottom: 3.5, left: 5 },
                        //                     }
                        //                 },
                        //                 {
                        //                     content: _sub.sub_review_comment,
                        //                     styles: {
                        //                         ...this.tableStyles.td,
                        //                         cellPadding: { top: 4.5, right: 5, bottom: 3.5, left: 5 }
                        //                     }
                        //                 },
                        //             ]
                        //         ]
                        //     })

                        //     position_y = doc.lastAutoTable.finalY
                        // }
                        
                        position_y += this.jsPDFOpt.spacing.section_xs
                    })
                })
            })

            return position_y
        },
        async generatePDF_hmc(doc, position_top) {
            // Factors 페이지 데이터 생성
            this.generateFactors()

            this.pageContentWidth = doc.internal.pageSize.width - (this.jsPDFOpt.margin.left + this.jsPDFOpt.margin.right)
            this.pageContentHeight = doc.internal.pageSize.height - (this.jsPDFOpt.margin.top + this.jsPDFOpt.margin.bottom)

            this.generateCover(doc)

            doc.addPage();
            this.addHeader(doc, 2);

            let position_y = await this.createSummaryPage_v4(doc, position_top)
            position_y = this.generateKeyFigurePage(doc, position_y)
            position_y = await this.generatePARAnalticsPage(doc, position_y)
            position_y = await this.generatePartialSummaryPage(doc, position_y)
            position_y = await this.generateCategory3AnalysisPage(doc, position_y)
            
            if (this.reportMode === "full") {
                this.createFactorsPage(doc, position_y)
            }

            const totalPages = doc.getNumberOfPages();
            for (let i = 2; i <= totalPages; i++) {
                doc.setPage(i);  // 현재 페이지로 이동
                this.addFooter(doc)
            }

            doc.setDocumentProperties({
                title: this.pdf_filename,
                subject: this.pdf_filename,
                filename: `${this.pdf_filename}.pdf`,
                author: 'QuantifiedESG Inc.',
                creator: 'QESG'
            })

            return doc
        }
    }
}
